// // // // // // import React, { useState, useEffect, useMemo } from "react";
// // // // // // import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
// // // // // // import { ThemeProvider as MuiThemeProvider, createTheme, CssBaseline, useMediaQuery } from "@mui/material";

// // // // // // // Import ThemeProvider and ThemeSelector
// // // // // // import { ThemeProvider } from "./css/ThemeContext";
// // // // // // import ThemeSelector from "./css/ThemeSelector";

// // // // // // // Layout
// // // // // // import MainLayout from "./MainLayout";

// // // // // // // Manager imports
// // // // // // import ManagerNewDashboard from './Manager/NewDashboard/ManagerNewDashboard';
// // // // // // import { Settings } from './Manager/Settings';
// // // // // // import { CreateCourse } from './Manager/create-course/CreateCourse';
// // // // // // import { ReportsTable } from "./Reports/ReportsTable";

// // // // // // // HR imports
// // // // // // import AssignCourse from "./HR/Assign_Course/AssignCourse";
// // // // // // import { ReportsUser } from "./Reports/ReportsUser";
// // // // // // import { ListofAssignmentExams } from "./HR/Assign_Course/list_of_assignments/ListofAssignmentExams";
// // // // // // import EmployeeSlotsTable from "./HR/EmployeeSlots/EmployeeSlotsTable";
// // // // // // import SlotBookingPage from "./HR/EmployeeSlots/SlotBooking"

// // // // // // // User Management / Auth
// // // // // // import Login from './UserManagement/Login';
// // // // // // import ChangePassword from './UserManagement/ChangeDefaultPassword';
// // // // // // import Designation from './UserManagement/Designation';
// // // // // // import Department from './UserManagement/Department';
// // // // // // import AssignMenu from './UserManagement/AssignMenu';
// // // // // // import PasswordPolicy from './UserManagement/PasswordPolicy';
// // // // // // import Salutation from './UserManagement/Salutation';
// // // // // // import Smtp from './UserManagement/Smtp';
// // // // // // import UserAndPlant from './UserManagement/UserAndPlant';
// // // // // // import UserPage from './UserManagement/UserCreation';
// // // // // // import LockAndUnlock from './UserManagement/UserLockAndUnlock';
// // // // // // import UserReset from './UserManagement/UserReset';
// // // // // // import AdminHome from './UserManagement/AdminHome';
// // // // // // import ChangePlant from './UserManagement/ChangePlant';
// // // // // // import SuperAdminHome from './UserManagement/SuperAdmin';
// // // // // // import ServiceProviderHome from './UserManagement/ServiceProvider';
// // // // // // import ErrorPage from './UserManagement/ErrorPage';
// // // // // // import TerminateLogin from './UserManagement/TerminateLoging';
// // // // // // import { AuthInterceptor } from './UserManagement/Logout';
// // // // // // import Instructions from './ExamPage/Instructions';
// // // // // // import VivaInstructions from './VivaExam/VivaInstructions';

// // // // // // import { ContentManagement } from "./UserManagement/ContentManagement";
// // // // // // import { RoleCreation } from "./UserManagement/RoleCreation";

// // // // // // // User
// // // // // // import ExamPortal from './ExamPage/Exam';
// // // // // // import NewUserDashboard from './User/NewUserDashboard';
// // // // // // import { VivaCompetitiveExam } from './VivaExam/VivaCompetitiveExam';
// // // // // // import AuthorizedRoute from "./Manager/hooks/exam_authorizedroute";
// // // // // // import AuthorizedRoutes from "./HR/Assign_Course/hooks/assignment_authorizedroute";

// // // // // // // Config
// // // // // // import BASE_URL from './config';
// // // // // // import ReviewPage from "./Review/Reviewpage";
// // // // // // import HRNewDashboard from "./HR/HRNewDashboard/HrNewDashboard";
// // // // // // import { ReportsUserWise } from "./Reports/UserWiseReports";
// // // // // // import LandingPage from "./Temp/Dashboard/LandingPage";
// // // // // // import OverviewTab from "./Manager/NewDashboard/components/OverviewTab";
// // // // // // import AnalyticsTab from "./Temp/components/AnalyticsTab";
// // // // // // import LeaderboardTab from "./Manager/NewDashboard/components/LeaderboardTab";

// // // // // // import ListofExams from "./Manager/list-of-exams/ListofExams";
// // // // // // import DashboardLayout from "./Temp/Dashboard/DashboardLayout";
// // // // // // import { Dashboard } from "./Dashboard/Dashboard";
// // // // // // import Intro from "./Dashboard/Intro";
// // // // // // import NewEmpDashboard from "./TempUser/NewEmpDashboard";
// // // // // // import Pdfviewer from "./pdf/Pdfviewer";
// // // // // // import DummyVivaInstructions from "./DummyViva/DummyVivaInstructions";
// // // // // // import { DummyRightCard } from "./DummyViva/DummyRightCard";
// // // // // // import DummyVivaCompetitiveExam from "./DummyViva/DummyVivaCompetitiveExam";
// // // // // // import { TourProvider } from "./User/TourContext";
// // // // // // import DummyExamInstructions from "./TempUser/UserWelcomeGuide/dummyExamInstructions";
// // // // // // import ConfirmStartDialogDemo from "./TempUser/UserWelcomeGuide/ConfirmStartDialogDemo";
// // // // // // import ExamPortalMock from "./TempUser/UserWelcomeGuide/ExamPortalMock";
// // // // // // import SubmitExamDialogDemo from "./TempUser/UserWelcomeGuide/SubmitExamDialogDemo";


// // // // // // import SSOPlant from "./Sso_ums/SsoPlant";


// // // // // // // ---------------- ProtectedRoute ----------------
// // // // // // const ProtectedRoute = ({ element }) => {
// // // // // //   const location = useLocation();
// // // // // //   const [allowedUrls, setAllowedUrls] = useState([]);
// // // // // //   const [error, setError] = useState(null);
// // // // // //   const [loading, setLoading] = useState(true);

// // // // // //   useEffect(() => {
// // // // // //     const fetchPayloadData = async () => {
// // // // // //       try {
// // // // // //         const res = await fetch(`/api/payload/`, { credentials: "include" });
// // // // // //         if (res.ok) {
// // // // // //           const data = await res.json();
// // // // // //           if (data?.payload) {
// // // // // //             const payload = data.payload;
// // // // // //             setAllowedUrls(payload.allowed_urls || []);
// // // // // //           } else {
// // // // // //             setError("No valid payload data found.");
// // // // // //           }
// // // // // //         } else {
// // // // // //           setError("Failed to fetch payload data.");
// // // // // //         }
// // // // // //       } catch (err) {
// // // // // //         console.error("Error fetching payload:", err);
// // // // // //         setError("Error fetching payload data.");
// // // // // //       } finally {
// // // // // //         setLoading(false);
// // // // // //       }
// // // // // //     };

// // // // // //     fetchPayloadData();
// // // // // //   }, []);

// // // // // //   const normalizedPath = location.pathname.toLowerCase().replace(/\/+$/, "").split("?")[0].split("#")[0];

// // // // // //   if (loading) return <div>Loading...</div>;
// // // // // //   if (error) return <Navigate to="/error" />;

// // // // // //   const normalizedAllowed = allowedUrls.map((url) => url.toLowerCase().replace(/\/+$/, ""));
// // // // // //   const isAllowed = normalizedAllowed.some((url) => normalizedPath === url || normalizedPath.endsWith(url));

// // // // // //   return isAllowed ? element : <Navigate to="/error" />;
// // // // // // };

// // // // // // // ---------------- AppWrapper ----------------
// // // // // // function AppWrapper() {
// // // // // //   const preferDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
// // // // // //   const [mode, setMode] = useState("light");
// // // // // //   const navigate = useNavigate();

// // // // // //   useEffect(() => {
// // // // // //     AuthInterceptor(navigate);
// // // // // //   }, [navigate]);

// // // // // //   useEffect(() => {
// // // // // //     const savedMode = localStorage.getItem("themeMode");
// // // // // //     if (savedMode) {
// // // // // //       setMode(savedMode);
// // // // // //     } else {
// // // // // //       setMode(preferDarkMode ? "dark" : "light");
// // // // // //     }
// // // // // //   }, [preferDarkMode]);



// // // // // //   const toggleTheme = () => {
// // // // // //     setMode((prev) => {
// // // // // //       const next = prev === "light" ? "dark" : "light";
// // // // // //       localStorage.setItem("themeMode", next);
// // // // // //       return next;
// // // // // //     });
// // // // // //   };

// // // // // //   const theme = useMemo(
// // // // // //     () =>
// // // // // //       createTheme({
// // // // // //         palette: { mode },
// // // // // //         components: {
// // // // // //           MuiCssBaseline: {
// // // // // //             styleOverrides: {
// // // // // //               ".table.table-striped tbody tr:nth-of-type(odd), .table.table-striped tbody tr:nth-of-type(even)": {
// // // // // //                 backgroundColor: mode === "dark" ? "#1e1e1e" : "#f5f5f5",
// // // // // //                 color: mode === "dark" ? "#fff" : "#000",
// // // // // //               },
// // // // // //             },
// // // // // //           },
// // // // // //         },
// // // // // //       }),
// // // // // //     [mode]
// // // // // //   );

// // // // // //   return (
// // // // // //     <MuiThemeProvider theme={theme}>
// // // // // //       <CssBaseline />
// // // // // //       {/* Theme Selector - Always visible */}
// // // // // //       <ThemeSelector />

// // // // // //       <Routes>
// // // // // //         {/* Public routes */}
// // // // // //         {/* <Route path="/" element={<Login />} /> */}

// // // // // //         <Route path="/ChangeDefaultPassword" element={<ChangePassword />} />
// // // // // //         <Route path="/ex" element={<Intro />} />


// // // // // //         {/* All main routes with Navigationbar */}
// // // // // //         <Route element={<MainLayout mode={mode} toggleTheme={toggleTheme} />}>
// // // // // //           <Route element={<DashboardLayout />}>
// // // // // //             {/* These routes will show landing page without sidebar */}
// // // // // //             <Route path="/managers" element={<LandingPage />} />
// // // // // //             <Route path="/managers/dashboard" element={<Dashboard />} />
// // // // // //             <Route path="/hr/dashboard" element={<Dashboard />} />


// // // // // //             <Route
// // // // // //               path="/managers/dashboard/upcomingexams"
// // // // // //               element={<OverviewTab mode="upcoming" />}
// // // // // //             />
// // // // // //             <Route
// // // // // //               path="/managers/dashboard/completedexams"
// // // // // //               element={<OverviewTab mode="completed" />}
// // // // // //             />
// // // // // //             <Route
// // // // // //               path="/managers/dashboard/leaderboards"
// // // // // //               element={<LeaderboardTab />}
// // // // // //             />

// // // // // //             <Route path="/managers/exams-list" element={<ListofExams />} />
// // // // // //             <Route path="/managers/create-course/:type/:examid" element={<CreateCourse />} />
// // // // // //             <Route path="/reports" element={<ReportsTable />} />
// // // // // //             <Route path="/report/users" element={<ReportsUser />} />


// // // // // //             <Route
// // // // // //               path="/hr/dashboard/upcomingexams"
// // // // // //               element={<OverviewTab mode="upcoming" />}
// // // // // //             />
// // // // // //             <Route
// // // // // //               path="/hr/dashboard/completedexams"
// // // // // //               element={<OverviewTab mode="completed" />}
// // // // // //             />
// // // // // //             <Route
// // // // // //               path="/hr/dashboard/leaderboards"
// // // // // //               element={<LeaderboardTab />}
// // // // // //             />

// // // // // //             {/* <Route path="/hr/dashboard/overview" element={<OverviewTab />} />
// // // // // //             <Route path="/hr/dashboard/analytics" element={<AnalyticsTab />} />
// // // // // //             <Route path="/hr/dashboard/leaderboards" element={<LeaderboardTab />} /> */}
// // // // // //             <Route path="/hr/assign-course" element={<AssignCourse />} />
// // // // // //             <Route path="/hr/assignment-exams" element={<ListofAssignmentExams />} />
// // // // // //             <Route path="/hr/employee-slots" element={<EmployeeSlotsTable />} />
// // // // // //             <Route path="/hr/slots" element={<SlotBookingPage />} />


// // // // // //             <Route path="/designation" element={<ProtectedRoute element={<Designation />} />} />
// // // // // //             <Route path="/Department" element={<ProtectedRoute element={<Department />} />} />
// // // // // //             <Route path="/AssignMenu" element={<ProtectedRoute element={<AssignMenu />} />} />
// // // // // //             <Route path="/PasswordPolicy" element={<ProtectedRoute element={<PasswordPolicy />} />} />
// // // // // //             <Route path="/Salutation" element={<ProtectedRoute element={<Salutation />} />} />
// // // // // //             <Route path="/Smtp" element={<ProtectedRoute element={<Smtp />} />} />
// // // // // //             <Route path="/UserAndPlant" element={<ProtectedRoute element={<UserAndPlant />} />} />
// // // // // //             <Route path="/UserCreation" element={<ProtectedRoute element={<UserPage />} />} />
// // // // // //             <Route path="/LockAndUnlock" element={<ProtectedRoute element={<LockAndUnlock />} />} />
// // // // // //             <Route path="/UserReset" element={<ProtectedRoute element={<UserReset />} />} />
// // // // // //             <Route path="/contentmanagement" element={<ContentManagement />} />
// // // // // //             <Route path="/rolecreation" element={<RoleCreation />} />
// // // // // //             <Route path="/" element={< SSOPlant/>} />

// // // // // //             {/* Other routes that also use navbar */}
// // // // // //             <Route path="/AdminHome" element={<AdminHome />} />
// // // // // //             <Route path="/SuperAdminHome" element={<SuperAdminHome />} />
// // // // // //             <Route path="/ServiceProviderHome" element={<ServiceProviderHome />} />
// // // // // //             <Route path="/ChangePlant" element={<ChangePlant />} />
// // // // // //             <Route path="/ChangePassword" element={<ChangePassword />} />

// // // // // //             <Route path="/error" element={<ErrorPage />} />
// // // // // //             <Route path="/terminatepage" element={<TerminateLogin />} />

// // // // // //             {/* Reports */}
// // // // // //             <Route path='/report' element={<ReportsTable />} />
// // // // // //             <Route path='/report/users' element={<ReportsUser />} />
// // // // // //             <Route path='/user/reports' element={<ReportsUserWise />} />

// // // // // //             {/* User Reports */}


// // // // // //             <Route path='/' element={<SSOPlant />} />

// // // // // //             {/* <Route path='/user/dashboard' element={<NewUserDashboard />} /> */}

// // // // // //             <Route path='/users/dashboard' element={<NewEmpDashboard />} />

// // // // // //             <Route path="/review" element={<ReviewPage />} />
// // // // // //           </Route>

// // // // // //           {/* Protected Routes */}

// // // // // //         </Route>
// // // // // //         <Route path='/instructions' element={<Instructions />} />
// // // // // //         <Route path="/instructions/:ee_id" element={<VivaInstructions />} />
// // // // // //         <Route path="/vivaexam/:ee_id" element={<VivaCompetitiveExam />} />
// // // // // //         <Route path='/assignment' element={<ExamPortal />} />
// // // // // //         <Route path='/user/reports' element={<ReportsUserWise />} />

// // // // // //         {/* Standalone pages (no navbar) */}
// // // // // //         <Route path="/dummy-instructions" element={<DummyExamInstructions />} />
// // // // // //         <Route path="/confirm-startdialogdemo" element={<ConfirmStartDialogDemo />} />
// // // // // //         <Route path="/examportal-mock" element={<ExamPortalMock />} />
// // // // // //         <Route path="/submitexamdialog-demo" element={<SubmitExamDialogDemo />} />




// // // // // //         <Route path="/pdfreport" element={<Pdfviewer />} />
// // // // // //         <Route
// // // // // //           path="/dummy-viva-instructions"
// // // // // //           element={
// // // // // //             <DummyVivaInstructions />} />
// // // // // //         <Route path='/dummy-viva-exam' element={<DummyVivaCompetitiveExam />} />

// // // // // //         {/* Standalone pages (no navbar) */}

// // // // // //       </Routes>




// // // // // //       {/* Protected Routes */}

// // // // // //       {/* Standalone pages (no navbar) */}
// // // // // //     </MuiThemeProvider>
// // // // // //   );
// // // // // // }


// // // // // // // function AppWrapper() {


// // // // // // //   const location = useLocation();
// // // // // // //   const navigate = useNavigate();

// // // // // // //   useEffect(() => {
// // // // // // //     const params = new URLSearchParams(location.search);
// // // // // // //     const code = params.get("code");

// // // // // // //     // 🚫 DO NOT run interceptor during SSO
// // // // // // //     if (!code) {
// // // // // // //       AuthInterceptor(navigate);
// // // // // // //     }
// // // // // // //   }, [navigate, location]);


// // // // // // // }

// // // // // // // ---------------- Root App ----------------
// // // // // // export default function App() {
// // // // // //   return (
// // // // // //     <BrowserRouter>
// // // // // //       <ThemeProvider>
// // // // // //         <TourProvider>
// // // // // //           <AppWrapper />
// // // // // //         </TourProvider>
// // // // // //       </ThemeProvider>
// // // // // //     </BrowserRouter>
// // // // // //   );
// // // // // // }


// // // // // import React, { useState, useEffect, useMemo } from "react";
// // // // // import {
// // // // //   BrowserRouter,
// // // // //   Routes,
// // // // //   Route,
// // // // //   Navigate,
// // // // //   useNavigate,
// // // // //   useLocation,
// // // // // } from "react-router-dom";

// // // // // import {
// // // // //   ThemeProvider as MuiThemeProvider,
// // // // //   createTheme,
// // // // //   CssBaseline,
// // // // //   useMediaQuery,
// // // // //   Dialog,
// // // // //   DialogTitle,
// // // // //   DialogContent,
// // // // //   DialogActions,
// // // // //   Button,
// // // // //   Box,
// // // // //   Typography
// // // // // } from "@mui/material";

// // // // // // Theme
// // // // // import { ThemeProvider } from "./css/ThemeContext";
// // // // // import ThemeSelector from "./css/ThemeSelector";

// // // // // // Layout
// // // // // import MainLayout from "./MainLayout";
// // // // // import DashboardLayout from "./Temp/Dashboard/DashboardLayout";

// // // // // // Auth
// // // // // import { AuthInterceptor } from "./UserManagement/Logout";

// // // // // // Pages
// // // // // import ChangePassword from "./UserManagement/ChangeDefaultPassword";
// // // // // import ErrorPage from "./UserManagement/ErrorPage";
// // // // // import AdminHome from "./UserManagement/AdminHome";
// // // // // import SuperAdminHome from "./UserManagement/SuperAdmin";
// // // // // import ServiceProviderHome from "./UserManagement/ServiceProvider";
// // // // // import ChangePlant from "./UserManagement/ChangePlant";

// // // // // import AssignCourse from "./HR/Assign_Course/AssignCourse";
// // // // // import ListofAssignmentExams from "./HR/Assign_Course/list_of_assignments/ListofAssignmentExams";
// // // // // import EmployeeSlotsTable from "./HR/EmployeeSlots/EmployeeSlotsTable";
// // // // // import SlotBookingPage from "./HR/EmployeeSlots/SlotBooking";

// // // // // import { ReportsTable } from "./Reports/ReportsTable";
// // // // // import { ReportsUser } from "./Reports/ReportsUser";
// // // // // import { ReportsUserWise } from "./Reports/UserWiseReports";

// // // // // import LandingPage from "./Temp/Dashboard/LandingPage";
// // // // // import { Dashboard } from "./Dashboard/Dashboard";
// // // // // import OverviewTab from "./Manager/NewDashboard/components/OverviewTab";
// // // // // import LeaderboardTab from "./Manager/NewDashboard/components/LeaderboardTab";

// // // // // import ListofExams from "./Manager/list-of-exams/ListofExams";
// // // // // import { CreateCourse } from "./Manager/create-course/CreateCourse";

// // // // // import ReviewPage from "./Review/Reviewpage";
// // // // // import NewEmpDashboard from "./TempUser/NewEmpDashboard";

// // // // // import Instructions from "./ExamPage/Instructions";
// // // // // import VivaInstructions from "./VivaExam/VivaInstructions";
// // // // // import { VivaCompetitiveExam } from "./VivaExam/VivaCompetitiveExam";
// // // // // import ExamPortal from "./ExamPage/Exam";

// // // // // import Pdfviewer from "./pdf/Pdfviewer";

// // // // // import DummyExamInstructions from "./TempUser/UserWelcomeGuide/dummyExamInstructions";
// // // // // import ConfirmStartDialogDemo from "./TempUser/UserWelcomeGuide/ConfirmStartDialogDemo";
// // // // // import ExamPortalMock from "./TempUser/UserWelcomeGuide/ExamPortalMock";
// // // // // import SubmitExamDialogDemo from "./TempUser/UserWelcomeGuide/SubmitExamDialogDemo";

// // // // // import DummyVivaInstructions from "./DummyViva/DummyVivaInstructions";
// // // // // import DummyVivaCompetitiveExam from "./DummyViva/DummyVivaCompetitiveExam";

// // // // // import { TourProvider } from "./User/TourContext";

// // // // // // SSO
// // // // // import SSOPlant from "./Sso_ums/SsoPlant";

// // // // // import AdminCategoryConfig from "./AdminConfig/AdminCategoryConfig";

// // // // // // ---------------- ProtectedRoute ----------------
// // // // // const ProtectedRoute = ({ element }) => {
// // // // //   const location = useLocation();
// // // // //   const [allowedUrls, setAllowedUrls] = useState([]);
// // // // //   const [error, setError] = useState(null);
// // // // //   const [loading, setLoading] = useState(true);

// // // // //   // useEffect(() => {
// // // // //   //   const fetchPayloadData = async () => {
// // // // //   //     try {
// // // // //   //       const res = await fetch(`/api/payload/`, {
// // // // //   //         credentials: "include",
// // // // //   //       });

// // // // //   //       if (res.ok) {
// // // // //   //         const data = await res.json();
// // // // //   //         setAllowedUrls(data?.payload?.allowed_urls || []);
// // // // //   //       } else {
// // // // //   //         setError("Failed to fetch payload");
// // // // //   //       }
// // // // //   //     } catch (err) {
// // // // //   //       setError("Error fetching payload");
// // // // //   //     } finally {
// // // // //   //       setLoading(false);
// // // // //   //     }
// // // // //   //   };

// // // // //   //   fetchPayloadData();
// // // // //   // }, []);

// // // // //   const path = location.pathname.toLowerCase();

// // // // //   if (loading) return <div>Loading...</div>;
// // // // //   if (error) return <Navigate to="/error" />;

// // // // //   const isAllowed = allowedUrls.some((url) =>
// // // // //     path.endsWith(url.toLowerCase())
// // // // //   );

// // // // //   return isAllowed ? element : <Navigate to="/error" />;
// // // // // };

// // // // // // ---------------- AppWrapper ----------------
// // // // // function AppWrapper() {
// // // // //   const preferDarkMode = useMediaQuery("(prefers-color-scheme: dark)");

// // // // //   const [mode, setMode] = useState("light");

// // // // //   const [openExitDialog, setOpenExitDialog] = useState(false);

// // // // //   const navigate = useNavigate();
// // // // //   const location = useLocation();

// // // // //   useEffect(() => {

// // // // //     window.history.pushState(
// // // // //       null,
// // // // //       "",
// // // // //       window.location.href
// // // // //     );


// // // // //     const handleBack = () => {

// // // // //       setOpenExitDialog(true);


// // // // //       window.history.pushState(
// // // // //         null,
// // // // //         "",
// // // // //         window.location.href
// // // // //       );

// // // // //     };


// // // // //     window.addEventListener(
// // // // //       "popstate",
// // // // //       handleBack
// // // // //     );


// // // // //     return () => {

// // // // //       window.removeEventListener(
// // // // //         "popstate",
// // // // //         handleBack
// // // // //       );

// // // // //     };


// // // // //   }, []);


// // // // //   useEffect(() => {

// // // // //     const handleRefresh = (event) => {

// // // // //       event.preventDefault();

// // // // //       event.returnValue = "";

// // // // //     };


// // // // //     window.addEventListener(
// // // // //       "beforeunload",
// // // // //       handleRefresh
// // // // //     );


// // // // //     return () => {

// // // // //       window.removeEventListener(
// // // // //         "beforeunload",
// // // // //         handleRefresh
// // // // //       );

// // // // //     };


// // // // //   }, []);

// // // // //   useEffect(() => {


// // // // //     const handleRefresh = (event) => {

// // // // //       event.preventDefault();

// // // // //       event.returnValue = "";

// // // // //     };


// // // // //     window.addEventListener(
// // // // //       "beforeunload",
// // // // //       handleRefresh
// // // // //     );


// // // // //     return () => {

// // // // //       window.removeEventListener(
// // // // //         "beforeunload",
// // // // //         handleRefresh
// // // // //       );

// // // // //     };


// // // // //   }, []);

// // // // //   // ✅ SSO-safe interceptor
// // // // //   useEffect(() => {
// // // // //     const params = new URLSearchParams(location.search);
// // // // //     const code = params.get("code");
// // // // //     console.log(code, "codeeeeeeeeeee")


// // // // //   }, [navigate, location]);

// // // // //   // Theme setup
// // // // //   useEffect(() => {
// // // // //     const savedMode = localStorage.getItem("themeMode");
// // // // //     setMode(savedMode || (preferDarkMode ? "dark" : "light"));
// // // // //   }, [preferDarkMode]);

// // // // //   const toggleTheme = () => {
// // // // //     setMode((prev) => {
// // // // //       const next = prev === "light" ? "dark" : "light";
// // // // //       localStorage.setItem("themeMode", next);
// // // // //       return next;
// // // // //     });
// // // // //   };

// // // // //   const theme = useMemo(
// // // // //     () =>
// // // // //       createTheme({
// // // // //         palette: { mode },
// // // // //       }),
// // // // //     [mode]
// // // // //   );

// // // // //   return (
// // // // //     <MuiThemeProvider theme={theme}>
// // // // //       <CssBaseline />
// // // // //       <ThemeSelector />


// // // // //       <Dialog

// // // // //         open={openExitDialog}

// // // // //         onClose={() => setOpenExitDialog(false)}

// // // // //         PaperProps={{
// // // // //           sx: {
// // // // //             width: "400px",
// // // // //             borderRadius: "16px",
// // // // //             padding: "10px"
// // // // //           }
// // // // //         }}

// // // // //       >


// // // // //         <DialogTitle>

// // // // //           <Typography
// // // // //             sx={{
// // // // //               fontSize: "22px",
// // // // //               fontWeight: 700,
// // // // //               textAlign: "center"
// // // // //             }}
// // // // //           >

// // // // //             Leave this page?

// // // // //           </Typography>


// // // // //         </DialogTitle>




// // // // //         <DialogContent>

// // // // //           <Typography

// // // // //             sx={{
// // // // //               textAlign: "center",
// // // // //               color: "#555"
// // // // //             }}

// // // // //           >

// // // // //             Are you sure you want to go back?

// // // // //             Any unsaved changes may be lost.

// // // // //           </Typography>


// // // // //         </DialogContent>




// // // // //         <DialogActions

// // // // //           sx={{
// // // // //             justifyContent: "center",
// // // // //             gap: 2,
// // // // //             pb: 3
// // // // //           }}

// // // // //         >


// // // // //           <Button

// // // // //             variant="outlined"

// // // // //             onClick={() =>
// // // // //               setOpenExitDialog(false)
// // // // //             }

// // // // //           >

// // // // //             Stay

// // // // //           </Button>



// // // // //           <Button

// // // // //             variant="contained"

// // // // //             color="error"

// // // // //             onClick={() => {


// // // // //               setOpenExitDialog(false);


// // // // //               window.history.go(-2);


// // // // //             }}

// // // // //           >

// // // // //             Leave

// // // // //           </Button>



// // // // //         </DialogActions>


// // // // //       </Dialog>



// // // // //       <Routes>
// // // // //         {/* Public */}
// // // // //         <Route path="/ChangeDefaultPassword" element={<ChangePassword />} />
// // // // //         <Route path="/" element={<SSOPlant />} />

// // // // //         {/* Main Layout */}
// // // // //         <Route element={<MainLayout mode={mode} toggleTheme={toggleTheme} />}>
// // // // //           <Route element={<DashboardLayout />}>

// // // // //             <Route path="/admin/:category" element={<AdminCategoryConfig />} />

// // // // //             {/* SSO Entry */}


// // // // //             {/* Dashboards */}
// // // // //             <Route path="/managers" element={<LandingPage />} />
// // // // //             <Route path="/managers/dashboard" element={<Dashboard />} />
// // // // //             <Route path="/hr/dashboard" element={<Dashboard />} />

// // // // //             {/* Tabs */}
// // // // //             <Route path="/managers/dashboard/upcomingexams" element={<OverviewTab mode="upcoming" />} />
// // // // //             <Route path="/managers/dashboard/completedexams" element={<OverviewTab mode="completed" />} />
// // // // //             <Route path="/managers/dashboard/leaderboards" element={<LeaderboardTab />} />

// // // // //             {/* HR */}
// // // // //             <Route path="/hr/assign-course" element={<AssignCourse />} />
// // // // //             <Route path="/hr/assignment-exams" element={<ListofAssignmentExams />} />
// // // // //             <Route path="/hr/employee-slots" element={<EmployeeSlotsTable />} />
// // // // //             <Route path="/hr/slots" element={<SlotBookingPage />} />


// // // // //             <Route path="/hr/dashboard/upcomingexams" element={<OverviewTab mode="upcoming" />} />
// // // // //             <Route path="/hr/dashboard/completedexams" element={<OverviewTab mode="completed" />} />
// // // // //             <Route path="/hr/dashboard/leaderboards" element={<LeaderboardTab />} />

// // // // //             {/* Manager */}
// // // // //             <Route path="/managers/exams-list" element={<ListofExams />} />
// // // // //             <Route path="/managers/create-course/:type/:examid" element={<CreateCourse />} />

// // // // //             {/* Reports */}
// // // // //             <Route path="/report" element={<ReportsTable />} />
// // // // //             <Route path="/report/users" element={<ReportsUser />} />
// // // // //             <Route path="/user/reports" element={<ReportsUserWise />} />

// // // // //             {/* User */}
// // // // //             <Route path="/users/dashboard" element={<NewEmpDashboard />} />

// // // // //             {/* Navigation */}
// // // // //             <Route path="/AdminHome" element={<AdminHome />} />
// // // // //             <Route path="/SuperAdminHome" element={<SuperAdminHome />} />
// // // // //             <Route path="/ServiceProviderHome" element={<ServiceProviderHome />} />
// // // // //             <Route path="/ChangePlant" element={<ChangePlant />} />

// // // // //             <Route path="/review" element={<ReviewPage />} />
// // // // //             <Route path="/error" element={<ErrorPage />} />
// // // // //           </Route>
// // // // //         </Route>

// // // // //         {/* Standalone */}
// // // // //         <Route path="/instructions" element={<Instructions />} />
// // // // //         <Route path="/instructions/:ee_id" element={<VivaInstructions />} />
// // // // //         <Route path="/vivaexam/:ee_id" element={<VivaCompetitiveExam />} />
// // // // //         <Route path="/assignment" element={<ExamPortal />} />

// // // // //         <Route path="/pdfreport" element={<Pdfviewer />} />

// // // // //         {/* Dummy */}
// // // // //         <Route path="/dummy-instructions" element={<DummyExamInstructions />} />
// // // // //         <Route path="/confirm-startdialogdemo" element={<ConfirmStartDialogDemo />} />
// // // // //         <Route path="/examportal-mock" element={<ExamPortalMock />} />
// // // // //         <Route path="/submitexamdialog-demo" element={<SubmitExamDialogDemo />} />
// // // // //         <Route path="/dummy-viva-instructions" element={<DummyVivaInstructions />} />
// // // // //         <Route path="/dummy-viva-exam" element={<DummyVivaCompetitiveExam />} />


// // // // //         {/* Admin Config */}

// // // // //       </Routes>
// // // // //     </MuiThemeProvider>
// // // // //   );
// // // // // }

// // // // // // ---------------- Root ----------------
// // // // // export default function App() {
// // // // //   return (
// // // // //     <BrowserRouter>
// // // // //       <ThemeProvider>
// // // // //         <TourProvider>
// // // // //           <AppWrapper />
// // // // //         </TourProvider>
// // // // //       </ThemeProvider>
// // // // //     </BrowserRouter>
// // // // //   );
// // // // // }




// // // // // import React, { useState, useEffect, useMemo } from "react";
// // // // // import {
// // // // //   BrowserRouter,
// // // // //   Routes,
// // // // //   Route,
// // // // //   Navigate,
// // // // //   useNavigate,
// // // // //   useLocation,
// // // // // } from "react-router-dom";

// // // // // import {
// // // // //   ThemeProvider as MuiThemeProvider,
// // // // //   createTheme,
// // // // //   CssBaseline,
// // // // //   useMediaQuery,
// // // // //   Dialog,
// // // // //   DialogTitle,
// // // // //   DialogContent,
// // // // //   DialogActions,
// // // // //   Button,
// // // // //   Box,
// // // // //   Typography
// // // // // } from "@mui/material";

// // // // // // Theme
// // // // // import { ThemeProvider } from "./css/ThemeContext";
// // // // // import ThemeSelector from "./css/ThemeSelector";

// // // // // // Layout
// // // // // import MainLayout from "./MainLayout";
// // // // // import DashboardLayout from "./Temp/Dashboard/DashboardLayout";

// // // // // // Auth
// // // // // import { AuthInterceptor } from "./UserManagement/Logout";

// // // // // // Pages
// // // // // import ChangePassword from "./UserManagement/ChangeDefaultPassword";
// // // // // import ErrorPage from "./UserManagement/ErrorPage";
// // // // // import AdminHome from "./UserManagement/AdminHome";
// // // // // import SuperAdminHome from "./UserManagement/SuperAdmin";
// // // // // import ServiceProviderHome from "./UserManagement/ServiceProvider";
// // // // // import ChangePlant from "./UserManagement/ChangePlant";

// // // // // import AssignCourse from "./HR/Assign_Course/AssignCourse";
// // // // // import ListofAssignmentExams from "./HR/Assign_Course/list_of_assignments/ListofAssignmentExams";
// // // // // import EmployeeSlotsTable from "./HR/EmployeeSlots/EmployeeSlotsTable";
// // // // // import SlotBookingPage from "./HR/EmployeeSlots/SlotBooking";

// // // // // import { ReportsTable } from "./Reports/ReportsTable";
// // // // // import { ReportsUser } from "./Reports/ReportsUser";
// // // // // import { ReportsUserWise } from "./Reports/UserWiseReports";

// // // // // import LandingPage from "./Temp/Dashboard/LandingPage";
// // // // // import { Dashboard } from "./Dashboard/Dashboard";
// // // // // import OverviewTab from "./Manager/NewDashboard/components/OverviewTab";
// // // // // import LeaderboardTab from "./Manager/NewDashboard/components/LeaderboardTab";

// // // // // import ListofExams from "./Manager/list-of-exams/ListofExams";
// // // // // import { CreateCourse } from "./Manager/create-course/CreateCourse";

// // // // // import ReviewPage from "./Review/Reviewpage";
// // // // // import NewEmpDashboard from "./TempUser/NewEmpDashboard";

// // // // // import Instructions from "./ExamPage/Instructions";
// // // // // import VivaInstructions from "./VivaExam/VivaInstructions";
// // // // // import { VivaCompetitiveExam } from "./VivaExam/VivaCompetitiveExam";
// // // // // import ExamPortal from "./ExamPage/Exam";

// // // // // import Pdfviewer from "./pdf/Pdfviewer";

// // // // // import DummyExamInstructions from "./TempUser/UserWelcomeGuide/dummyExamInstructions";
// // // // // import ConfirmStartDialogDemo from "./TempUser/UserWelcomeGuide/ConfirmStartDialogDemo";
// // // // // import ExamPortalMock from "./TempUser/UserWelcomeGuide/ExamPortalMock";
// // // // // import SubmitExamDialogDemo from "./TempUser/UserWelcomeGuide/SubmitExamDialogDemo";

// // // // // import DummyVivaInstructions from "./DummyViva/DummyVivaInstructions";
// // // // // import DummyVivaCompetitiveExam from "./DummyViva/DummyVivaCompetitiveExam";

// // // // // import { TourProvider } from "./User/TourContext";

// // // // // // SSO
// // // // // import SSOPlant from "./Sso_ums/SsoPlant";

// // // // // import AdminCategoryConfig from "./AdminConfig/AdminCategoryConfig";

// // // // // // ---------------- ProtectedRoute ----------------
// // // // // const ProtectedRoute = ({ element }) => {
// // // // //   const location = useLocation();
// // // // //   const [allowedUrls, setAllowedUrls] = useState([]);
// // // // //   const [error, setError] = useState(null);
// // // // //   const [loading, setLoading] = useState(true);

// // // // //   // useEffect(() => {
// // // // //   //   const fetchPayloadData = async () => {
// // // // //   //     try {
// // // // //   //       const res = await fetch(`/api/payload/`, {
// // // // //   //         credentials: "include",
// // // // //   //       });

// // // // //   //       if (res.ok) {
// // // // //   //         const data = await res.json();
// // // // //   //         setAllowedUrls(data?.payload?.allowed_urls || []);
// // // // //   //       } else {
// // // // //   //         setError("Failed to fetch payload");
// // // // //   //       }
// // // // //   //     } catch (err) {
// // // // //   //       setError("Error fetching payload");
// // // // //   //     } finally {
// // // // //   //       setLoading(false);
// // // // //   //     }
// // // // //   //   };

// // // // //   //   fetchPayloadData();
// // // // //   // }, []);

// // // // //   const path = location.pathname.toLowerCase();

// // // // //   if (loading) return <div>Loading...</div>;
// // // // //   if (error) return <Navigate to="/error" />;

// // // // //   const isAllowed = allowedUrls.some((url) =>
// // // // //     path.endsWith(url.toLowerCase())
// // // // //   );

// // // // //   return isAllowed ? element : <Navigate to="/error" />;
// // // // // };

// // // // // // ---------------- AppWrapper ----------------
// // // // // // ---------------- AppWrapper ----------------
// // // // // function AppWrapper() {

// // // // //   const preferDarkMode = useMediaQuery("(prefers-color-scheme: dark)");

// // // // //   const [mode, setMode] = useState("light");

// // // // //   const [openExitDialog, setOpenExitDialog] = useState(false);

// // // // //   const navigate = useNavigate();

// // // // //   const location = useLocation();



// // // // //   // ============================
// // // // //   // Browser BACK button dialog
// // // // //   // ============================
// // // // //   useEffect(() => {


// // // // //     window.history.pushState(
// // // // //       null,
// // // // //       "",
// // // // //       window.location.href
// // // // //     );


// // // // //     const handleBack = () => {


// // // // //       setOpenExitDialog(true);



// // // // //       // prevent actual back
// // // // //       window.history.pushState(
// // // // //         null,
// // // // //         "",
// // // // //         window.location.href
// // // // //       );


// // // // //     };



// // // // //     window.addEventListener(
// // // // //       "popstate",
// // // // //       handleBack
// // // // //     );



// // // // //     return () => {


// // // // //       window.removeEventListener(
// // // // //         "popstate",
// // // // //         handleBack
// // // // //       );


// // // // //     };


// // // // //   }, []);





// // // // //   // ============================
// // // // //   // Refresh / F5 / Close tab
// // // // //   // ============================
// // // // //   useEffect(() => {


// // // // //     const handleRefresh = (event) => {


// // // // //       event.preventDefault();


// // // // //       // Required by browser
// // // // //       event.returnValue = "";


// // // // //     };



// // // // //     window.addEventListener(
// // // // //       "beforeunload",
// // // // //       handleRefresh
// // // // //     );



// // // // //     return () => {


// // // // //       window.removeEventListener(
// // // // //         "beforeunload",
// // // // //         handleRefresh
// // // // //       );


// // // // //     };


// // // // //   }, []);

// // // // //   // ✅ SSO-safe interceptor
// // // // //   useEffect(() => {
// // // // //     const params = new URLSearchParams(location.search);
// // // // //     const code = params.get("code");
// // // // //     console.log(code, "codeeeeeeeeeee")


// // // // //   }, [navigate, location]);

// // // // //   // Theme setup
// // // // //   useEffect(() => {
// // // // //     const savedMode = localStorage.getItem("themeMode");
// // // // //     setMode(savedMode || (preferDarkMode ? "dark" : "light"));
// // // // //   }, [preferDarkMode]);

// // // // //   const toggleTheme = () => {
// // // // //     setMode((prev) => {
// // // // //       const next = prev === "light" ? "dark" : "light";
// // // // //       localStorage.setItem("themeMode", next);
// // // // //       return next;
// // // // //     });
// // // // //   };

// // // // //   const theme = useMemo(
// // // // //     () =>
// // // // //       createTheme({
// // // // //         palette: { mode },
// // // // //       }),
// // // // //     [mode]
// // // // //   );

// // // // //   return (
// // // // //     <MuiThemeProvider theme={theme}>
// // // // //       <CssBaseline />
// // // // //       <ThemeSelector />


// // // // //       <Dialog

// // // // //         open={openExitDialog}

// // // // //         onClose={() => setOpenExitDialog(false)}

// // // // //         PaperProps={{
// // // // //           sx: {
// // // // //             width: "400px",
// // // // //             borderRadius: "16px",
// // // // //             padding: "10px"
// // // // //           }
// // // // //         }}

// // // // //       >


// // // // //         <DialogTitle>

// // // // //           <Typography
// // // // //             sx={{
// // // // //               fontSize: "22px",
// // // // //               fontWeight: 700,
// // // // //               textAlign: "center"
// // // // //             }}
// // // // //           >

// // // // //             Leave this page?

// // // // //           </Typography>


// // // // //         </DialogTitle>




// // // // //         <DialogContent>

// // // // //           <Typography

// // // // //             sx={{
// // // // //               textAlign: "center",
// // // // //               color: "#555"
// // // // //             }}

// // // // //           >

// // // // //             Are you sure you want to go back?

// // // // //             Any unsaved changes may be lost.

// // // // //           </Typography>


// // // // //         </DialogContent>




// // // // //         <DialogActions

// // // // //           sx={{
// // // // //             justifyContent: "center",
// // // // //             gap: 2,
// // // // //             pb: 3
// // // // //           }}

// // // // //         >


// // // // //           <Button

// // // // //             variant="outlined"

// // // // //             onClick={() =>
// // // // //               setOpenExitDialog(false)
// // // // //             }

// // // // //           >

// // // // //             Stay

// // // // //           </Button>



// // // // //           <Button

// // // // //             variant="contained"

// // // // //             color="error"

// // // // //             onClick={() => {


// // // // //               setOpenExitDialog(false);


// // // // // window.history.back();

// // // // //             }}

// // // // //           >

// // // // //             Leave

// // // // //           </Button>



// // // // //         </DialogActions>


// // // // //       </Dialog>



// // // // //       <Routes>
// // // // //         {/* Public */}
// // // // //         <Route path="/ChangeDefaultPassword" element={<ChangePassword />} />
// // // // //         <Route path="/" element={<SSOPlant />} />

// // // // //         {/* Main Layout */}
// // // // //         <Route element={<MainLayout mode={mode} toggleTheme={toggleTheme} />}>
// // // // //           <Route element={<DashboardLayout />}>

// // // // //             <Route path="/admin/:category" element={<AdminCategoryConfig />} />

// // // // //             {/* SSO Entry */}


// // // // //             {/* Dashboards */}
// // // // //             <Route path="/managers" element={<LandingPage />} />
// // // // //             <Route path="/managers/dashboard" element={<Dashboard />} />
// // // // //             <Route path="/hr/dashboard" element={<Dashboard />} />

// // // // //             {/* Tabs */}
// // // // //             <Route path="/managers/dashboard/upcomingexams" element={<OverviewTab mode="upcoming" />} />
// // // // //             <Route path="/managers/dashboard/completedexams" element={<OverviewTab mode="completed" />} />
// // // // //             <Route path="/managers/dashboard/leaderboards" element={<LeaderboardTab />} />

// // // // //             {/* HR */}
// // // // //             <Route path="/hr/assign-course" element={<AssignCourse />} />
// // // // //             <Route path="/hr/assignment-exams" element={<ListofAssignmentExams />} />
// // // // //             <Route path="/hr/employee-slots" element={<EmployeeSlotsTable />} />
// // // // //             <Route path="/hr/slots" element={<SlotBookingPage />} />


// // // // //             <Route path="/hr/dashboard/upcomingexams" element={<OverviewTab mode="upcoming" />} />
// // // // //             <Route path="/hr/dashboard/completedexams" element={<OverviewTab mode="completed" />} />
// // // // //             <Route path="/hr/dashboard/leaderboards" element={<LeaderboardTab />} />

// // // // //             {/* Manager */}
// // // // //             <Route path="/managers/exams-list" element={<ListofExams />} />
// // // // //             <Route path="/managers/create-course/:type/:examid" element={<CreateCourse />} />

// // // // //             {/* Reports */}
// // // // //             <Route path="/report" element={<ReportsTable />} />
// // // // //             <Route path="/report/users" element={<ReportsUser />} />
// // // // //             <Route path="/user/reports" element={<ReportsUserWise />} />

// // // // //             {/* User */}
// // // // //             <Route path="/users/dashboard" element={<NewEmpDashboard />} />

// // // // //             {/* Navigation */}
// // // // //             <Route path="/AdminHome" element={<AdminHome />} />
// // // // //             <Route path="/SuperAdminHome" element={<SuperAdminHome />} />
// // // // //             <Route path="/ServiceProviderHome" element={<ServiceProviderHome />} />
// // // // //             <Route path="/ChangePlant" element={<ChangePlant />} />

// // // // //             <Route path="/review" element={<ReviewPage />} />
// // // // //             <Route path="/error" element={<ErrorPage />} />
// // // // //           </Route>
// // // // //         </Route>

// // // // //         {/* Standalone */}
// // // // //         <Route path="/instructions" element={<Instructions />} />
// // // // //         <Route path="/instructions/:ee_id" element={<VivaInstructions />} />
// // // // //         <Route path="/vivaexam/:ee_id" element={<VivaCompetitiveExam />} />
// // // // //         <Route path="/assignment" element={<ExamPortal />} />

// // // // //         <Route path="/pdfreport" element={<Pdfviewer />} />

// // // // //         {/* Dummy */}
// // // // //         <Route path="/dummy-instructions" element={<DummyExamInstructions />} />
// // // // //         <Route path="/confirm-startdialogdemo" element={<ConfirmStartDialogDemo />} />
// // // // //         <Route path="/examportal-mock" element={<ExamPortalMock />} />
// // // // //         <Route path="/submitexamdialog-demo" element={<SubmitExamDialogDemo />} />
// // // // //         <Route path="/dummy-viva-instructions" element={<DummyVivaInstructions />} />
// // // // //         <Route path="/dummy-viva-exam" element={<DummyVivaCompetitiveExam />} />


// // // // //         {/* Admin Config */}

// // // // //       </Routes>
// // // // //     </MuiThemeProvider>
// // // // //   );
// // // // // }

// // // // // // ---------------- Root ----------------
// // // // // export default function App() {
// // // // //   return (
// // // // //     <BrowserRouter>
// // // // //       <ThemeProvider>
// // // // //         <TourProvider>
// // // // //           <AppWrapper />
// // // // //         </TourProvider>
// // // // //       </ThemeProvider>
// // // // //     </BrowserRouter>
// // // // //   );
// // // // // }

// // // // import React, { useState, useEffect, useMemo, useCallback } from "react";
// // // // import {
// // // //   BrowserRouter,
// // // //   Routes,
// // // //   Route,
// // // //   Navigate,
// // // //   useNavigate,
// // // //   useLocation,
// // // // } from "react-router-dom";

// // // // import {
// // // //   ThemeProvider as MuiThemeProvider,
// // // //   createTheme,
// // // //   CssBaseline,
// // // //   useMediaQuery,
// // // //   Dialog,
// // // //   DialogTitle,
// // // //   DialogContent,
// // // //   DialogActions,
// // // //   Button,
// // // //   Box,
// // // //   Typography
// // // // } from "@mui/material";

// // // // // Theme
// // // // import { ThemeProvider } from "./css/ThemeContext";
// // // // import ThemeSelector from "./css/ThemeSelector";

// // // // // Layout
// // // // import MainLayout from "./MainLayout";
// // // // import DashboardLayout from "./Temp/Dashboard/DashboardLayout";

// // // // // Auth
// // // // import { AuthInterceptor } from "./UserManagement/Logout";

// // // // // Pages
// // // // import ChangePassword from "./UserManagement/ChangeDefaultPassword";
// // // // import ErrorPage from "./UserManagement/ErrorPage";
// // // // import AdminHome from "./UserManagement/AdminHome";
// // // // import SuperAdminHome from "./UserManagement/SuperAdmin";
// // // // import ServiceProviderHome from "./UserManagement/ServiceProvider";
// // // // import ChangePlant from "./UserManagement/ChangePlant";

// // // // import AssignCourse from "./HR/Assign_Course/AssignCourse";
// // // // import ListofAssignmentExams from "./HR/Assign_Course/list_of_assignments/ListofAssignmentExams";
// // // // import EmployeeSlotsTable from "./HR/EmployeeSlots/EmployeeSlotsTable";
// // // // import SlotBookingPage from "./HR/EmployeeSlots/SlotBooking";

// // // // import { ReportsTable } from "./Reports/ReportsTable";
// // // // import { ReportsUser } from "./Reports/ReportsUser";
// // // // import { ReportsUserWise } from "./Reports/UserWiseReports";

// // // // import LandingPage from "./Temp/Dashboard/LandingPage";
// // // // import { Dashboard } from "./Dashboard/Dashboard";
// // // // import OverviewTab from "./Manager/NewDashboard/components/OverviewTab";
// // // // import LeaderboardTab from "./Manager/NewDashboard/components/LeaderboardTab";

// // // // import ListofExams from "./Manager/list-of-exams/ListofExams";
// // // // import { CreateCourse } from "./Manager/create-course/CreateCourse";

// // // // import ReviewPage from "./Review/Reviewpage";
// // // // import NewEmpDashboard from "./TempUser/NewEmpDashboard";

// // // // import Instructions from "./ExamPage/Instructions";
// // // // import VivaInstructions from "./VivaExam/VivaInstructions";
// // // // import { VivaCompetitiveExam } from "./VivaExam/VivaCompetitiveExam";
// // // // import ExamPortal from "./ExamPage/Exam";

// // // // import Pdfviewer from "./pdf/Pdfviewer";

// // // // import DummyExamInstructions from "./TempUser/UserWelcomeGuide/dummyExamInstructions";
// // // // import ConfirmStartDialogDemo from "./TempUser/UserWelcomeGuide/ConfirmStartDialogDemo";
// // // // import ExamPortalMock from "./TempUser/UserWelcomeGuide/ExamPortalMock";
// // // // import SubmitExamDialogDemo from "./TempUser/UserWelcomeGuide/SubmitExamDialogDemo";

// // // // import DummyVivaInstructions from "./DummyViva/DummyVivaInstructions";
// // // // import DummyVivaCompetitiveExam from "./DummyViva/DummyVivaCompetitiveExam";

// // // // import { TourProvider } from "./User/TourContext";

// // // // // SSO
// // // // import SSOPlant from "./Sso_ums/SsoPlant";

// // // // import AdminCategoryConfig from "./AdminConfig/AdminCategoryConfig";

// // // // // ---------------- ProtectedRoute ----------------
// // // // const ProtectedRoute = ({ element }) => {
// // // //   const location = useLocation();
// // // //   const [allowedUrls, setAllowedUrls] = useState([]);
// // // //   const [error, setError] = useState(null);
// // // //   const [loading, setLoading] = useState(true);

// // // //   // useEffect(() => {
// // // //   //   const fetchPayloadData = async () => {
// // // //   //     try {
// // // //   //       const res = await fetch(`/api/payload/`, {
// // // //   //         credentials: "include",
// // // //   //       });

// // // //   //       if (res.ok) {
// // // //   //         const data = await res.json();
// // // //   //         setAllowedUrls(data?.payload?.allowed_urls || []);
// // // //   //       } else {
// // // //   //         setError("Failed to fetch payload");
// // // //   //       }
// // // //   //     } catch (err) {
// // // //   //       setError("Error fetching payload");
// // // //   //     } finally {
// // // //   //       setLoading(false);
// // // //   //     }
// // // //   //   };

// // // //   //   fetchPayloadData();
// // // //   // }, []);

// // // //   const path = location.pathname.toLowerCase();

// // // //   if (loading) return <div>Loading...</div>;
// // // //   if (error) return <Navigate to="/error" />;

// // // //   const isAllowed = allowedUrls.some((url) =>
// // // //     path.endsWith(url.toLowerCase())
// // // //   );

// // // //   return isAllowed ? element : <Navigate to="/error" />;
// // // // };

// // // // // ---------------- AppWrapper ----------------
// // // // function AppWrapper() {
// // // //   const preferDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
// // // //   const [mode, setMode] = useState("light");
// // // //   const [openExitDialog, setOpenExitDialog] = useState(false);
// // // //   const [pendingNavigation, setPendingNavigation] = useState(null);
// // // //   const [openRefreshDialog, setOpenRefreshDialog] = useState(false);
// // // //   const navigate = useNavigate();
// // // //   const location = useLocation();

// // // //   // ============================
// // // //   // Browser BACK button dialog
// // // //   // ============================
// // // //   useEffect(() => {
// // // //     // Push initial state
// // // //     window.history.pushState(null, "", window.location.href);

// // // //     const handleBack = (event) => {
// // // //       event.preventDefault();

// // // //       // Store the current location to navigate after confirmation
// // // //       setPendingNavigation(-1);
// // // //       setOpenExitDialog(true);

// // // //       // Push state again to prevent immediate back navigation
// // // //       window.history.pushState(null, "", window.location.href);
// // // //     };

// // // //     window.addEventListener("popstate", handleBack);

// // // //     return () => {
// // // //       window.removeEventListener("popstate", handleBack);
// // // //     };
// // // //   }, []);

// // // //   // ============================
// // // //   // Refresh / F5 / Close tab dialog
// // // //   // ============================
// // // //   useEffect(() => {
// // // //     let isRefreshDialogShown = false;

// // // //     const handleBeforeUnload = (event) => {
// // // //       // For Chrome, Edge, etc. - shows default browser dialog
// // // //       event.preventDefault();
// // // //       event.returnValue = "";

// // // //       // For our custom MUI dialog, we need to handle it differently
// // // //       // Since beforeunload doesn't allow custom dialogs, we'll show MUI dialog
// // // //       // when user tries to refresh
// // // //       if (!isRefreshDialogShown) {
// // // //         isRefreshDialogShown = true;
// // // //         setOpenRefreshDialog(true);
// // // //       }
// // // //     };

// // // //     // Detect F5 / Ctrl+R / Cmd+R
// // // //     const handleKeyDown = (event) => {
// // // //       // F5 key
// // // //       if (event.key === 'F5') {
// // // //         event.preventDefault();
// // // //         setOpenRefreshDialog(true);
// // // //         return;
// // // //       }

// // // //       // Ctrl+R or Cmd+R
// // // //       if ((event.ctrlKey || event.metaKey) && event.key === 'r') {
// // // //         event.preventDefault();
// // // //         setOpenRefreshDialog(true);
// // // //         return;
// // // //       }
// // // //     };

// // // //     // Detect browser refresh button (via beforeunload)
// // // //     window.addEventListener("beforeunload", handleBeforeUnload);

// // // //     // Detect keyboard shortcuts
// // // //     window.addEventListener("keydown", handleKeyDown);

// // // //     return () => {
// // // //       window.removeEventListener("beforeunload", handleBeforeUnload);
// // // //       window.removeEventListener("keydown", handleKeyDown);
// // // //       isRefreshDialogShown = false;
// // // //     };
// // // //   }, []);

// // // //   // ============================
// // // //   // Handle Leave action for Back button
// // // //   // ============================
// // // //   const handleLeaveBack = () => {
// // // //     setOpenExitDialog(false);

// // // //     // Navigate back using react-router's navigate
// // // //     if (pendingNavigation) {
// // // //       navigate(-1);
// // // //       setPendingNavigation(null);
// // // //     }
// // // //   };

// // // //   // ============================
// // // //   // Handle Stay action for Back button
// // // //   // ============================
// // // //   const handleStayBack = () => {
// // // //     setOpenExitDialog(false);
// // // //     setPendingNavigation(null);
// // // //     // Push state again to maintain back button prevention
// // // //     window.history.pushState(null, "", window.location.href);
// // // //   };

// // // //   // ============================
// // // //   // Handle Refresh actions
// // // //   // ============================
// // // //   const handleRefresh = () => {
// // // //     setOpenRefreshDialog(false);
// // // //     // Reload the page
// // // //     window.location.reload();
// // // //   };

// // // //   const handleStayRefresh = () => {
// // // //     setOpenRefreshDialog(false);
// // // //   };

// // // //   // ============================
// // // //   // SSO-safe interceptor
// // // //   // ============================
// // // //   useEffect(() => {
// // // //     const params = new URLSearchParams(location.search);
// // // //     const code = params.get("code");
// // // //     console.log(code, "codeeeeeeeeeee");
// // // //   }, [navigate, location]);

// // // //   // ============================
// // // //   // Theme setup
// // // //   // ============================
// // // //   useEffect(() => {
// // // //     const savedMode = localStorage.getItem("themeMode");
// // // //     setMode(savedMode || (preferDarkMode ? "dark" : "light"));
// // // //   }, [preferDarkMode]);

// // // //   const toggleTheme = () => {
// // // //     setMode((prev) => {
// // // //       const next = prev === "light" ? "dark" : "light";
// // // //       localStorage.setItem("themeMode", next);
// // // //       return next;
// // // //     });
// // // //   };

// // // //   const theme = useMemo(
// // // //     () =>
// // // //       createTheme({
// // // //         palette: { mode },
// // // //       }),
// // // //     [mode]
// // // //   );

// // // //   return (
// // // //     <MuiThemeProvider theme={theme}>
// // // //       <CssBaseline />
// // // //       <ThemeSelector />

// // // //       {/* ============================
// // // //           BACK BUTTON DIALOG
// // // //           ============================ */}
// // // //       <Dialog
// // // //         open={openExitDialog}
// // // //         onClose={handleStayBack}
// // // //         PaperProps={{
// // // //           sx: {
// // // //             width: "400px",
// // // //             borderRadius: "16px",
// // // //             padding: "10px"
// // // //           }
// // // //         }}
// // // //       >
// // // //         <DialogTitle>
// // // //           <Typography
// // // //             sx={{
// // // //               fontSize: "22px",
// // // //               fontWeight: 700,
// // // //               textAlign: "center"
// // // //             }}
// // // //           >
// // // //             Leave this page?
// // // //           </Typography>
// // // //         </DialogTitle>

// // // //         <DialogContent>
// // // //           <Typography
// // // //             sx={{
// // // //               textAlign: "center",
// // // //               color: "#555"
// // // //             }}
// // // //           >
// // // //             Are you sure you want to go back?
// // // //             Any unsaved changes may be lost.
// // // //           </Typography>
// // // //         </DialogContent>

// // // //         <DialogActions
// // // //           sx={{
// // // //             justifyContent: "center",
// // // //             gap: 2,
// // // //             pb: 3
// // // //           }}
// // // //         >
// // // //           <Button
// // // //             variant="outlined"
// // // //             onClick={handleStayBack}
// // // //           >
// // // //             Stay
// // // //           </Button>

// // // //           <Button
// // // //             variant="contained"
// // // //             color="error"
// // // //             onClick={handleLeaveBack}
// // // //           >
// // // //             Leave
// // // //           </Button>
// // // //         </DialogActions>
// // // //       </Dialog>

// // // //       {/* ============================
// // // //           REFRESH DIALOG
// // // //           ============================ */}
// // // //       <Dialog
// // // //         open={openRefreshDialog}
// // // //         onClose={handleStayRefresh}
// // // //         PaperProps={{
// // // //           sx: {
// // // //             width: "400px",
// // // //             borderRadius: "16px",
// // // //             padding: "10px"
// // // //           }
// // // //         }}
// // // //       >
// // // //         <DialogTitle>
// // // //           <Typography
// // // //             sx={{
// // // //               fontSize: "22px",
// // // //               fontWeight: 700,
// // // //               textAlign: "center"
// // // //             }}
// // // //           >
// // // //             Refresh this page?
// // // //           </Typography>
// // // //         </DialogTitle>

// // // //         <DialogContent>
// // // //           <Typography
// // // //             sx={{
// // // //               textAlign: "center",
// // // //               color: "#555"
// // // //             }}
// // // //           >
// // // //             Are you sure you want to refresh?
// // // //             Any unsaved changes may be lost.
// // // //           </Typography>
// // // //         </DialogContent>

// // // //         <DialogActions
// // // //           sx={{
// // // //             justifyContent: "center",
// // // //             gap: 2,
// // // //             pb: 3
// // // //           }}
// // // //         >
// // // //           <Button
// // // //             variant="outlined"
// // // //             onClick={handleStayRefresh}
// // // //           >
// // // //             Stay
// // // //           </Button>

// // // //           <Button
// // // //             variant="contained"
// // // //             color="error"
// // // //             onClick={handleRefresh}
// // // //           >
// // // //             Refresh
// // // //           </Button>
// // // //         </DialogActions>
// // // //       </Dialog>

// // // //       <Routes>
// // // //         {/* Public */}
// // // //         <Route path="/ChangeDefaultPassword" element={<ChangePassword />} />
// // // //         <Route path="/" element={<SSOPlant />} />

// // // //         {/* Main Layout */}
// // // //         <Route element={<MainLayout mode={mode} toggleTheme={toggleTheme} />}>
// // // //           <Route element={<DashboardLayout />}>
// // // //             <Route path="/admin/:category" element={<AdminCategoryConfig />} />

// // // //             {/* Dashboards */}
// // // //             <Route path="/managers" element={<LandingPage />} />
// // // //             <Route path="/managers/dashboard" element={<Dashboard />} />
// // // //             <Route path="/hr/dashboard" element={<Dashboard />} />

// // // //             {/* Tabs */}
// // // //             <Route path="/managers/dashboard/upcomingexams" element={<OverviewTab mode="upcoming" />} />
// // // //             <Route path="/managers/dashboard/completedexams" element={<OverviewTab mode="completed" />} />
// // // //             <Route path="/managers/dashboard/leaderboards" element={<LeaderboardTab />} />

// // // //             {/* HR */}
// // // //             <Route path="/hr/assign-course" element={<AssignCourse />} />
// // // //             <Route path="/hr/assignment-exams" element={<ListofAssignmentExams />} />
// // // //             <Route path="/hr/employee-slots" element={<EmployeeSlotsTable />} />
// // // //             <Route path="/hr/slots" element={<SlotBookingPage />} />

// // // //             <Route path="/hr/dashboard/upcomingexams" element={<OverviewTab mode="upcoming" />} />
// // // //             <Route path="/hr/dashboard/completedexams" element={<OverviewTab mode="completed" />} />
// // // //             <Route path="/hr/dashboard/leaderboards" element={<LeaderboardTab />} />

// // // //             {/* Manager */}
// // // //             <Route path="/managers/exams-list" element={<ListofExams />} />
// // // //             <Route path="/managers/create-course/:type/:examid" element={<CreateCourse />} />

// // // //             {/* Reports */}
// // // //             <Route path="/report" element={<ReportsTable />} />
// // // //             <Route path="/report/users" element={<ReportsUser />} />
// // // //             <Route path="/user/reports" element={<ReportsUserWise />} />

// // // //             {/* User */}
// // // //             <Route path="/users/dashboard" element={<NewEmpDashboard />} />

// // // //             {/* Navigation */}
// // // //             <Route path="/AdminHome" element={<AdminHome />} />
// // // //             <Route path="/SuperAdminHome" element={<SuperAdminHome />} />
// // // //             <Route path="/ServiceProviderHome" element={<ServiceProviderHome />} />
// // // //             <Route path="/ChangePlant" element={<ChangePlant />} />

// // // //             <Route path="/review" element={<ReviewPage />} />
// // // //             <Route path="/error" element={<ErrorPage />} />
// // // //           </Route>
// // // //         </Route>

// // // //         {/* Standalone */}
// // // //         <Route path="/instructions" element={<Instructions />} />
// // // //         <Route path="/instructions/:ee_id" element={<VivaInstructions />} />
// // // //         <Route path="/vivaexam/:ee_id" element={<VivaCompetitiveExam />} />
// // // //         <Route path="/assignment" element={<ExamPortal />} />

// // // //         <Route path="/pdfreport" element={<Pdfviewer />} />

// // // //         {/* Dummy */}
// // // //         <Route path="/dummy-instructions" element={<DummyExamInstructions />} />
// // // //         <Route path="/confirm-startdialogdemo" element={<ConfirmStartDialogDemo />} />
// // // //         <Route path="/examportal-mock" element={<ExamPortalMock />} />
// // // //         <Route path="/submitexamdialog-demo" element={<SubmitExamDialogDemo />} />
// // // //         <Route path="/dummy-viva-instructions" element={<DummyVivaInstructions />} />
// // // //         <Route path="/dummy-viva-exam" element={<DummyVivaCompetitiveExam />} />
// // // //       </Routes>
// // // //     </MuiThemeProvider>
// // // //   );
// // // // }

// // // // // ---------------- Root ----------------
// // // // export default function App() {
// // // //   return (
// // // //     <BrowserRouter>
// // // //       <ThemeProvider>
// // // //         <TourProvider>
// // // //           <AppWrapper />
// // // //         </TourProvider>
// // // //       </ThemeProvider>
// // // //     </BrowserRouter>
// // // //   );
// // // // }


// // // import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
// // // import {
// // //   BrowserRouter,
// // //   Routes,
// // //   Route,
// // //   Navigate,
// // //   useNavigate,
// // //   useLocation,
// // // } from "react-router-dom";

// // // import {
// // //   ThemeProvider as MuiThemeProvider,
// // //   createTheme,
// // //   CssBaseline,
// // //   useMediaQuery,
// // //   Dialog,
// // //   DialogTitle,
// // //   DialogContent,
// // //   DialogActions,
// // //   Button,
// // //   Box,
// // //   Typography
// // // } from "@mui/material";

// // // // Theme
// // // import { ThemeProvider } from "./css/ThemeContext";
// // // import ThemeSelector from "./css/ThemeSelector";

// // // // Layout
// // // import MainLayout from "./MainLayout";
// // // import DashboardLayout from "./Temp/Dashboard/DashboardLayout";

// // // // Auth
// // // import { AuthInterceptor } from "./UserManagement/Logout";

// // // // Pages
// // // import ChangePassword from "./UserManagement/ChangeDefaultPassword";
// // // import ErrorPage from "./UserManagement/ErrorPage";
// // // import AdminHome from "./UserManagement/AdminHome";
// // // import SuperAdminHome from "./UserManagement/SuperAdmin";
// // // import ServiceProviderHome from "./UserManagement/ServiceProvider";
// // // import ChangePlant from "./UserManagement/ChangePlant";

// // // import AssignCourse from "./HR/Assign_Course/AssignCourse";
// // // import ListofAssignmentExams from "./HR/Assign_Course/list_of_assignments/ListofAssignmentExams";
// // // import EmployeeSlotsTable from "./HR/EmployeeSlots/EmployeeSlotsTable";
// // // import SlotBookingPage from "./HR/EmployeeSlots/SlotBooking";

// // // import { ReportsTable } from "./Reports/ReportsTable";
// // // import { ReportsUser } from "./Reports/ReportsUser";
// // // import { ReportsUserWise } from "./Reports/UserWiseReports";

// // // import LandingPage from "./Temp/Dashboard/LandingPage";
// // // import { Dashboard } from "./Dashboard/Dashboard";
// // // import OverviewTab from "./Manager/NewDashboard/components/OverviewTab";
// // // import LeaderboardTab from "./Manager/NewDashboard/components/LeaderboardTab";

// // // import ListofExams from "./Manager/list-of-exams/ListofExams";
// // // import { CreateCourse } from "./Manager/create-course/CreateCourse";

// // // import ReviewPage from "./Review/Reviewpage";
// // // import NewEmpDashboard from "./TempUser/NewEmpDashboard";

// // // import Instructions from "./ExamPage/Instructions";
// // // import VivaInstructions from "./VivaExam/VivaInstructions";
// // // import { VivaCompetitiveExam } from "./VivaExam/VivaCompetitiveExam";
// // // import ExamPortal from "./ExamPage/Exam";

// // // import Pdfviewer from "./pdf/Pdfviewer";

// // // import DummyExamInstructions from "./TempUser/UserWelcomeGuide/dummyExamInstructions";
// // // import ConfirmStartDialogDemo from "./TempUser/UserWelcomeGuide/ConfirmStartDialogDemo";
// // // import ExamPortalMock from "./TempUser/UserWelcomeGuide/ExamPortalMock";
// // // import SubmitExamDialogDemo from "./TempUser/UserWelcomeGuide/SubmitExamDialogDemo";

// // // import DummyVivaInstructions from "./DummyViva/DummyVivaInstructions";
// // // import DummyVivaCompetitiveExam from "./DummyViva/DummyVivaCompetitiveExam";

// // // import { TourProvider } from "./User/TourContext";

// // // // SSO
// // // import SSOPlant from "./Sso_ums/SsoPlant";

// // // import AdminCategoryConfig from "./AdminConfig/AdminCategoryConfig";

// // // // ---------------- ProtectedRoute ----------------
// // // const ProtectedRoute = ({ element }) => {
// // //   const location = useLocation();
// // //   const [allowedUrls, setAllowedUrls] = useState([]);
// // //   const [error, setError] = useState(null);
// // //   const [loading, setLoading] = useState(true);

// // //   // useEffect(() => {
// // //   //   const fetchPayloadData = async () => {
// // //   //     try {
// // //   //       const res = await fetch(`/api/payload/`, {
// // //   //         credentials: "include",
// // //   //       });

// // //   //       if (res.ok) {
// // //   //         const data = await res.json();
// // //   //         setAllowedUrls(data?.payload?.allowed_urls || []);
// // //   //       } else {
// // //   //         setError("Failed to fetch payload");
// // //   //       }
// // //   //     } catch (err) {
// // //   //       setError("Error fetching payload");
// // //   //     } finally {
// // //   //       setLoading(false);
// // //   //     }
// // //   //   };

// // //   //   fetchPayloadData();
// // //   // }, []);

// // //   const path = location.pathname.toLowerCase();

// // //   if (loading) return <div>Loading...</div>;
// // //   if (error) return <Navigate to="/error" />;

// // //   const isAllowed = allowedUrls.some((url) =>
// // //     path.endsWith(url.toLowerCase())
// // //   );

// // //   return isAllowed ? element : <Navigate to="/error" />;
// // // };

// // // // ---------------- AppWrapper ----------------
// // // function AppWrapper() {
// // //   const preferDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
// // //   const [mode, setMode] = useState("light");
// // //   const [openExitDialog, setOpenExitDialog] = useState(false);
// // //   const [openRefreshDialog, setOpenRefreshDialog] = useState(false);
// // //   const [isNavigating, setIsNavigating] = useState(false);
// // //   const [isRefreshConfirmed, setIsRefreshConfirmed] = useState(false);
// // //   const navigate = useNavigate();
// // //   const location = useLocation();

// // //   // ============================
// // //   // Browser BACK button dialog
// // //   // ============================
// // //   useEffect(() => {
// // //     // Push initial state
// // //     window.history.pushState(null, "", window.location.href);

// // //     const handleBack = (event) => {
// // //       event.preventDefault();

// // //       // Don't show dialog if we're already navigating
// // //       if (isNavigating) {
// // //         return;
// // //       }

// // //       // Show the dialog
// // //       setOpenExitDialog(true);

// // //       // Push state again to prevent immediate back navigation
// // //       window.history.pushState(null, "", window.location.href);
// // //     };

// // //     window.addEventListener("popstate", handleBack);

// // //     return () => {
// // //       window.removeEventListener("popstate", handleBack);
// // //     };
// // //   }, [isNavigating]);

// // //   // ============================
// // //   // Refresh / F5 / Close tab dialog
// // //   // ============================
// // //   useEffect(() => {
// // //     // Flag to track if we've already shown the dialog
// // //     let dialogShown = false;

// // //     const handleBeforeUnload = (event) => {
// // //       // Prevent the default browser dialog
// // //       event.preventDefault();

// // //       // Only show our custom dialog if not already shown and not navigating
// // //       if (!dialogShown && !isNavigating && !isRefreshConfirmed) {
// // //         dialogShown = true;
// // //         setOpenRefreshDialog(true);

// // //         // We need to return a string for the browser's default dialog,
// // //         // but we'll prevent it from showing by using a custom approach
// // //         // The browser will still show its default dialog, but we'll handle it
// // //         event.returnValue = "";
// // //         return "";
// // //       }
// // //     };

// // //     // Detect F5 / Ctrl+R / Cmd+R
// // //     const handleKeyDown = (event) => {
// // //       // F5 key
// // //       if (event.key === 'F5') {
// // //         event.preventDefault();
// // //         if (!isNavigating && !isRefreshConfirmed) {
// // //           setOpenRefreshDialog(true);
// // //         }
// // //         return;
// // //       }

// // //       // Ctrl+R or Cmd+R
// // //       if ((event.ctrlKey || event.metaKey) && event.key === 'r') {
// // //         event.preventDefault();
// // //         if (!isNavigating && !isRefreshConfirmed) {
// // //           setOpenRefreshDialog(true);
// // //         }
// // //         return;
// // //       }
// // //     };

// // //     // Clean up the dialog flag after refresh is confirmed
// // //     if (isRefreshConfirmed) {
// // //       dialogShown = false;
// // //     }

// // //     window.addEventListener("beforeunload", handleBeforeUnload);
// // //     window.addEventListener("keydown", handleKeyDown);

// // //     return () => {
// // //       window.removeEventListener("beforeunload", handleBeforeUnload);
// // //       window.removeEventListener("keydown", handleKeyDown);
// // //       dialogShown = false;
// // //     };
// // //   }, [isNavigating, isRefreshConfirmed]);

// // //   // ============================
// // //   // Handle Leave action for Back button
// // //   // ============================
// // //   const handleLeaveBack = () => {
// // //     setOpenExitDialog(false);
// // //     setIsNavigating(true);

// // //     // Navigate back using react-router's navigate
// // //     navigate(-1);

// // //     // Reset the navigating flag after navigation
// // //     setTimeout(() => {
// // //       setIsNavigating(false);
// // //     }, 100);
// // //   };

// // //   // ============================
// // //   // Handle Stay action for Back button
// // //   // ============================
// // //   const handleStayBack = () => {
// // //     setOpenExitDialog(false);
// // //     // Push state again to maintain back button prevention
// // //     window.history.pushState(null, "", window.location.href);
// // //   };

// // //   // ============================
// // //   // Handle Refresh actions
// // //   // ============================
// // //   const handleRefresh = () => {
// // //     setOpenRefreshDialog(false);
// // //     setIsRefreshConfirmed(true);
// // //     setIsNavigating(true);

// // //     // Small delay to ensure state updates before reload
// // //     setTimeout(() => {
// // //       window.location.reload();
// // //     }, 100);
// // //   };

// // //   const handleStayRefresh = () => {
// // //     setOpenRefreshDialog(false);
// // //     setIsRefreshConfirmed(false);
// // //   };

// // //   // ============================
// // //   // SSO-safe interceptor
// // //   // ============================
// // //   useEffect(() => {
// // //     const params = new URLSearchParams(location.search);
// // //     const code = params.get("code");
// // //     console.log(code, "codeeeeeeeeeee");
// // //   }, [navigate, location]);

// // //   // ============================
// // //   // Theme setup
// // //   // ============================
// // //   useEffect(() => {
// // //     const savedMode = localStorage.getItem("themeMode");
// // //     setMode(savedMode || (preferDarkMode ? "dark" : "light"));
// // //   }, [preferDarkMode]);

// // //   const toggleTheme = () => {
// // //     setMode((prev) => {
// // //       const next = prev === "light" ? "dark" : "light";
// // //       localStorage.setItem("themeMode", next);
// // //       return next;
// // //     });
// // //   };

// // //   const theme = useMemo(
// // //     () =>
// // //       createTheme({
// // //         palette: { mode },
// // //       }),
// // //     [mode]
// // //   );

// // //   return (
// // //     <MuiThemeProvider theme={theme}>
// // //       <CssBaseline />
// // //       <ThemeSelector />

// // //       {/* ============================
// // //           BACK BUTTON DIALOG
// // //           ============================ */}
// // //       <Dialog
// // //         open={openExitDialog}
// // //         onClose={handleStayBack}
// // //         PaperProps={{
// // //           sx: {
// // //             width: "400px",
// // //             borderRadius: "16px",
// // //             padding: "10px"
// // //           }
// // //         }}
// // //       >
// // //         <DialogTitle>
// // //           <Typography
// // //             sx={{
// // //               fontSize: "22px",
// // //               fontWeight: 700,
// // //               textAlign: "center"
// // //             }}
// // //           >
// // //             Leave this page?
// // //           </Typography>
// // //         </DialogTitle>

// // //         <DialogContent>
// // //           <Typography
// // //             sx={{
// // //               textAlign: "center",
// // //               color: "#555"
// // //             }}
// // //           >
// // //             Are you sure you want to go back?
// // //             Any unsaved changes may be lost.
// // //           </Typography>
// // //         </DialogContent>

// // //         <DialogActions
// // //           sx={{
// // //             justifyContent: "center",
// // //             gap: 2,
// // //             pb: 3
// // //           }}
// // //         >
// // //           <Button
// // //             variant="outlined"
// // //             onClick={handleStayBack}
// // //           >
// // //             Stay
// // //           </Button>

// // //           <Button
// // //             variant="contained"
// // //             color="error"
// // //             onClick={handleLeaveBack}
// // //           >
// // //             Leave
// // //           </Button>
// // //         </DialogActions>
// // //       </Dialog>

// // //       {/* ============================
// // //           REFRESH DIALOG
// // //           ============================ */}
// // //       <Dialog
// // //         open={openRefreshDialog}
// // //         onClose={handleStayRefresh}
// // //         PaperProps={{
// // //           sx: {
// // //             width: "400px",
// // //             borderRadius: "16px",
// // //             padding: "10px"
// // //           }
// // //         }}
// // //       >
// // //         <DialogTitle>
// // //           <Typography
// // //             sx={{
// // //               fontSize: "22px",
// // //               fontWeight: 700,
// // //               textAlign: "center"
// // //             }}
// // //           >
// // //             Refresh this page?
// // //           </Typography>
// // //         </DialogTitle>

// // //         <DialogContent>
// // //           <Typography
// // //             sx={{
// // //               textAlign: "center",
// // //               color: "#555"
// // //             }}
// // //           >
// // //             Are you sure you want to refresh?
// // //             Any unsaved changes may be lost.
// // //           </Typography>
// // //         </DialogContent>

// // //         <DialogActions
// // //           sx={{
// // //             justifyContent: "center",
// // //             gap: 2,
// // //             pb: 3
// // //           }}
// // //         >
// // //           <Button
// // //             variant="outlined"
// // //             onClick={handleStayRefresh}
// // //           >
// // //             Stay
// // //           </Button>

// // //           <Button
// // //             variant="contained"
// // //             color="error"
// // //             onClick={handleRefresh}
// // //           >
// // //             Refresh
// // //           </Button>
// // //         </DialogActions>
// // //       </Dialog>

// // //       <Routes>
// // //         {/* Public */}
// // //         <Route path="/ChangeDefaultPassword" element={<ChangePassword />} />
// // //         <Route path="/" element={<SSOPlant />} />

// // //         {/* Main Layout */}
// // //         <Route element={<MainLayout mode={mode} toggleTheme={toggleTheme} />}>
// // //           <Route element={<DashboardLayout />}>
// // //             <Route path="/admin/:category" element={<AdminCategoryConfig />} />

// // //             {/* Dashboards */}
// // //             <Route path="/managers" element={<LandingPage />} />
// // //             <Route path="/managers/dashboard" element={<Dashboard />} />
// // //             <Route path="/hr/dashboard" element={<Dashboard />} />

// // //             {/* Tabs */}
// // //             <Route path="/managers/dashboard/upcomingexams" element={<OverviewTab mode="upcoming" />} />
// // //             <Route path="/managers/dashboard/completedexams" element={<OverviewTab mode="completed" />} />
// // //             <Route path="/managers/dashboard/leaderboards" element={<LeaderboardTab />} />

// // //             {/* HR */}
// // //             <Route path="/hr/assign-course" element={<AssignCourse />} />
// // //             <Route path="/hr/assignment-exams" element={<ListofAssignmentExams />} />
// // //             <Route path="/hr/employee-slots" element={<EmployeeSlotsTable />} />
// // //             <Route path="/hr/slots" element={<SlotBookingPage />} />

// // //             <Route path="/hr/dashboard/upcomingexams" element={<OverviewTab mode="upcoming" />} />
// // //             <Route path="/hr/dashboard/completedexams" element={<OverviewTab mode="completed" />} />
// // //             <Route path="/hr/dashboard/leaderboards" element={<LeaderboardTab />} />

// // //             {/* Manager */}
// // //             <Route path="/managers/exams-list" element={<ListofExams />} />
// // //             <Route path="/managers/create-course/:type/:examid" element={<CreateCourse />} />

// // //             {/* Reports */}
// // //             <Route path="/report" element={<ReportsTable />} />
// // //             <Route path="/report/users" element={<ReportsUser />} />
// // //             <Route path="/user/reports" element={<ReportsUserWise />} />

// // //             {/* User */}
// // //             <Route path="/users/dashboard" element={<NewEmpDashboard />} />

// // //             {/* Navigation */}
// // //             <Route path="/AdminHome" element={<AdminHome />} />
// // //             <Route path="/SuperAdminHome" element={<SuperAdminHome />} />
// // //             <Route path="/ServiceProviderHome" element={<ServiceProviderHome />} />
// // //             <Route path="/ChangePlant" element={<ChangePlant />} />

// // //             <Route path="/review" element={<ReviewPage />} />
// // //             <Route path="/error" element={<ErrorPage />} />
// // //           </Route>
// // //         </Route>

// // //         {/* Standalone */}
// // //         <Route path="/instructions" element={<Instructions />} />
// // //         <Route path="/instructions/:ee_id" element={<VivaInstructions />} />
// // //         <Route path="/vivaexam/:ee_id" element={<VivaCompetitiveExam />} />
// // //         <Route path="/assignment" element={<ExamPortal />} />

// // //         <Route path="/pdfreport" element={<Pdfviewer />} />

// // //         {/* Dummy */}
// // //         <Route path="/dummy-instructions" element={<DummyExamInstructions />} />
// // //         <Route path="/confirm-startdialogdemo" element={<ConfirmStartDialogDemo />} />
// // //         <Route path="/examportal-mock" element={<ExamPortalMock />} />
// // //         <Route path="/submitexamdialog-demo" element={<SubmitExamDialogDemo />} />
// // //         <Route path="/dummy-viva-instructions" element={<DummyVivaInstructions />} />
// // //         <Route path="/dummy-viva-exam" element={<DummyVivaCompetitiveExam />} />
// // //       </Routes>
// // //     </MuiThemeProvider>
// // //   );
// // // }

// // // // ---------------- Root ----------------
// // // export default function App() {
// // //   return (
// // //     <BrowserRouter>
// // //       <ThemeProvider>
// // //         <TourProvider>
// // //           <AppWrapper />
// // //         </TourProvider>
// // //       </ThemeProvider>
// // //     </BrowserRouter>
// // //   );
// // // }




// // import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
// // import {
// //   BrowserRouter,
// //   Routes,
// //   Route,
// //   Navigate,
// //   useNavigate,
// //   useLocation,
// // } from "react-router-dom";

// // import {
// //   ThemeProvider as MuiThemeProvider,
// //   createTheme,
// //   CssBaseline,
// //   useMediaQuery,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   Button,
// //   Box,
// //   Typography
// // } from "@mui/material";

// // // Theme
// // import { ThemeProvider } from "./css/ThemeContext";
// // import ThemeSelector from "./css/ThemeSelector";

// // // Layout
// // import MainLayout from "./MainLayout";
// // import DashboardLayout from "./Temp/Dashboard/DashboardLayout";

// // // Auth
// // import { AuthInterceptor } from "./UserManagement/Logout";

// // // Pages
// // import ChangePassword from "./UserManagement/ChangeDefaultPassword";
// // import ErrorPage from "./UserManagement/ErrorPage";
// // import AdminHome from "./UserManagement/AdminHome";
// // import SuperAdminHome from "./UserManagement/SuperAdmin";
// // import ServiceProviderHome from "./UserManagement/ServiceProvider";
// // import ChangePlant from "./UserManagement/ChangePlant";

// // import AssignCourse from "./HR/Assign_Course/AssignCourse";
// // import ListofAssignmentExams from "./HR/Assign_Course/list_of_assignments/ListofAssignmentExams";
// // import EmployeeSlotsTable from "./HR/EmployeeSlots/EmployeeSlotsTable";
// // import SlotBookingPage from "./HR/EmployeeSlots/SlotBooking";

// // import { ReportsTable } from "./Reports/ReportsTable";
// // import { ReportsUser } from "./Reports/ReportsUser";
// // import { ReportsUserWise } from "./Reports/UserWiseReports";

// // import LandingPage from "./Temp/Dashboard/LandingPage";
// // import { Dashboard } from "./Dashboard/Dashboard";
// // import OverviewTab from "./Manager/NewDashboard/components/OverviewTab";
// // import LeaderboardTab from "./Manager/NewDashboard/components/LeaderboardTab";

// // import ListofExams from "./Manager/list-of-exams/ListofExams";
// // import { CreateCourse } from "./Manager/create-course/CreateCourse";

// // import ReviewPage from "./Review/Reviewpage";
// // import NewEmpDashboard from "./TempUser/NewEmpDashboard";

// // import Instructions from "./ExamPage/Instructions";
// // import VivaInstructions from "./VivaExam/VivaInstructions";
// // import { VivaCompetitiveExam } from "./VivaExam/VivaCompetitiveExam";
// // import ExamPortal from "./ExamPage/Exam";

// // import Pdfviewer from "./pdf/Pdfviewer";

// // import DummyExamInstructions from "./TempUser/UserWelcomeGuide/dummyExamInstructions";
// // import ConfirmStartDialogDemo from "./TempUser/UserWelcomeGuide/ConfirmStartDialogDemo";
// // import ExamPortalMock from "./TempUser/UserWelcomeGuide/ExamPortalMock";
// // import SubmitExamDialogDemo from "./TempUser/UserWelcomeGuide/SubmitExamDialogDemo";

// // import DummyVivaInstructions from "./DummyViva/DummyVivaInstructions";
// // import DummyVivaCompetitiveExam from "./DummyViva/DummyVivaCompetitiveExam";

// // import { TourProvider } from "./User/TourContext";

// // // SSO
// // import SSOPlant from "./Sso_ums/SsoPlant";

// // import AdminCategoryConfig from "./AdminConfig/AdminCategoryConfig";

// // // ---------------- ProtectedRoute ----------------
// // const ProtectedRoute = ({ element }) => {
// //   const location = useLocation();
// //   const [allowedUrls, setAllowedUrls] = useState([]);
// //   const [error, setError] = useState(null);
// //   const [loading, setLoading] = useState(true);

// //   // useEffect(() => {
// //   //   const fetchPayloadData = async () => {
// //   //     try {
// //   //       const res = await fetch(`/api/payload/`, {
// //   //         credentials: "include",
// //   //       });

// //   //       if (res.ok) {
// //   //         const data = await res.json();
// //   //         setAllowedUrls(data?.payload?.allowed_urls || []);
// //   //       } else {
// //   //         setError("Failed to fetch payload");
// //   //       }
// //   //     } catch (err) {
// //   //       setError("Error fetching payload");
// //   //     } finally {
// //   //       setLoading(false);
// //   //     }
// //   //   };

// //   //   fetchPayloadData();
// //   // }, []);

// //   const path = location.pathname.toLowerCase();

// //   if (loading) return <div>Loading...</div>;
// //   if (error) return <Navigate to="/error" />;

// //   const isAllowed = allowedUrls.some((url) =>
// //     path.endsWith(url.toLowerCase())
// //   );

// //   return isAllowed ? element : <Navigate to="/error" />;
// // };

// // // ---------------- AppWrapper ----------------
// // function AppWrapper() {
// //   const preferDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
// //   const [mode, setMode] = useState("light");
// //   const [openExitDialog, setOpenExitDialog] = useState(false);
// //   const [openRefreshDialog, setOpenRefreshDialog] = useState(false);
// //   const [isNavigating, setIsNavigating] = useState(false);
// //   const [pendingRefresh, setPendingRefresh] = useState(false);
// //   const navigate = useNavigate();
// //   const location = useLocation();

// //   // ============================
// //   // Browser BACK button dialog
// //   // ============================
// //   useEffect(() => {
// //     // Push initial state
// //     window.history.pushState(null, "", window.location.href);

// //     const handleBack = (event) => {
// //       event.preventDefault();

// //       // Don't show dialog if we're already navigating
// //       if (isNavigating) {
// //         return;
// //       }

// //       // Show the dialog
// //       setOpenExitDialog(true);

// //       // Push state again to prevent immediate back navigation
// //       window.history.pushState(null, "", window.location.href);
// //     };

// //     window.addEventListener("popstate", handleBack);

// //     return () => {
// //       window.removeEventListener("popstate", handleBack);
// //     };
// //   }, [isNavigating]);

// //   // ============================
// //   // Refresh / F5 / Close tab dialog
// //   // ============================
// //   useEffect(() => {
// //     // Handle browser refresh
// //     const handleBeforeUnload = (event) => {
// //       // Only show our dialog if not already navigating and not already refreshing
// //       if (!isNavigating && !pendingRefresh) {
// //         // Prevent the default browser dialog
// //         event.preventDefault();
// //         event.returnValue = "";

// //         // Show our custom dialog
// //         setOpenRefreshDialog(true);

// //         // We need to keep the event alive to prevent navigation
// //         return "";
// //       }
// //     };

// //     // Detect F5 / Ctrl+R / Cmd+R
// //     const handleKeyDown = (event) => {
// //       // F5 key
// //       if (event.key === 'F5') {
// //         event.preventDefault();
// //         if (!isNavigating && !pendingRefresh) {
// //           setOpenRefreshDialog(true);
// //         }
// //         return;
// //       }

// //       // Ctrl+R or Cmd+R
// //       if ((event.ctrlKey || event.metaKey) && event.key === 'r') {
// //         event.preventDefault();
// //         if (!isNavigating && !pendingRefresh) {
// //           setOpenRefreshDialog(true);
// //         }
// //         return;
// //       }
// //     };

// //     window.addEventListener("beforeunload", handleBeforeUnload);
// //     window.addEventListener("keydown", handleKeyDown);

// //     return () => {
// //       window.removeEventListener("beforeunload", handleBeforeUnload);
// //       window.removeEventListener("keydown", handleKeyDown);
// //     };
// //   }, [isNavigating, pendingRefresh]);

// //   // ============================
// //   // Handle Leave action for Back button
// //   // ============================
// //   const handleLeaveBack = () => {
// //     setOpenExitDialog(false);
// //     setIsNavigating(true);

// //     // Navigate back using react-router's navigate
// //     navigate(-1);

// //     // Reset the navigating flag after navigation
// //     setTimeout(() => {
// //       setIsNavigating(false);
// //     }, 100);
// //   };

// //   // ============================
// //   // Handle Stay action for Back button
// //   // ============================
// //   const handleStayBack = () => {
// //     setOpenExitDialog(false);
// //     // Push state again to maintain back button prevention
// //     window.history.pushState(null, "", window.location.href);
// //   };

// //   // ============================
// //   // Handle Refresh actions
// //   // ============================
// //   const handleRefresh = () => {
// //     setOpenRefreshDialog(false);
// //     setPendingRefresh(true);
// //     setIsNavigating(true);

// //     // Small delay to ensure state updates before reload
// //     setTimeout(() => {
// //       window.location.reload();
// //     }, 50);
// //   };

// //   const handleStayRefresh = () => {
// //     setOpenRefreshDialog(false);
// //     setPendingRefresh(false);
// //   };

// //   // ============================
// //   // SSO-safe interceptor
// //   // ============================
// //   useEffect(() => {
// //     const params = new URLSearchParams(location.search);
// //     const code = params.get("code");
// //     console.log(code, "codeeeeeeeeeee");
// //   }, [navigate, location]);

// //   // ============================
// //   // Theme setup
// //   // ============================
// //   useEffect(() => {
// //     const savedMode = localStorage.getItem("themeMode");
// //     setMode(savedMode || (preferDarkMode ? "dark" : "light"));
// //   }, [preferDarkMode]);

// //   const toggleTheme = () => {
// //     setMode((prev) => {
// //       const next = prev === "light" ? "dark" : "light";
// //       localStorage.setItem("themeMode", next);
// //       return next;
// //     });
// //   };

// //   const theme = useMemo(
// //     () =>
// //       createTheme({
// //         palette: { mode },
// //       }),
// //     [mode]
// //   );

// //   return (
// //     <MuiThemeProvider theme={theme}>
// //       <CssBaseline />
// //       <ThemeSelector />

// //       {/* ============================
// //           BACK BUTTON DIALOG
// //           ============================ */}
// //       <Dialog
// //         open={openExitDialog}
// //         onClose={handleStayBack}
// //         PaperProps={{
// //           sx: {
// //             width: "400px",
// //             borderRadius: "16px",
// //             padding: "10px"
// //           }
// //         }}
// //       >
// //         <DialogTitle>
// //           <Typography
// //             sx={{
// //               fontSize: "22px",
// //               fontWeight: 700,
// //               textAlign: "center"
// //             }}
// //           >
// //             Leave this page?
// //           </Typography>
// //         </DialogTitle>

// //         <DialogContent>
// //           <Typography
// //             sx={{
// //               textAlign: "center",
// //               color: "#555"
// //             }}
// //           >
// //             Are you sure you want to go back?
// //             Any unsaved changes may be lost.
// //           </Typography>
// //         </DialogContent>

// //         <DialogActions
// //           sx={{
// //             justifyContent: "center",
// //             gap: 2,
// //             pb: 3
// //           }}
// //         >
// //           <Button
// //             variant="outlined"
// //             onClick={handleStayBack}
// //           >
// //             Stay
// //           </Button>

// //           <Button
// //             variant="contained"
// //             color="error"
// //             onClick={handleLeaveBack}
// //           >
// //             Leave
// //           </Button>
// //         </DialogActions>
// //       </Dialog>

// //       {/* ============================
// //           REFRESH DIALOG
// //           ============================ */}
// //       <Dialog
// //         open={openRefreshDialog}
// //         onClose={handleStayRefresh}
// //         PaperProps={{
// //           sx: {
// //             width: "400px",
// //             borderRadius: "16px",
// //             padding: "10px"
// //           }
// //         }}
// //       >
// //         <DialogTitle>
// //           <Typography
// //             sx={{
// //               fontSize: "22px",
// //               fontWeight: 700,
// //               textAlign: "center"
// //             }}
// //           >
// //             Refresh this page?
// //           </Typography>
// //         </DialogTitle>

// //         <DialogContent>
// //           <Typography
// //             sx={{
// //               textAlign: "center",
// //               color: "#555"
// //             }}
// //           >
// //             Are you sure you want to refresh?
// //             Any unsaved changes may be lost.
// //           </Typography>
// //         </DialogContent>

// //         <DialogActions
// //           sx={{
// //             justifyContent: "center",
// //             gap: 2,
// //             pb: 3
// //           }}
// //         >
// //           <Button
// //             variant="outlined"
// //             onClick={handleStayRefresh}
// //           >
// //             Stay
// //           </Button>

// //           <Button
// //             variant="contained"
// //             color="error"
// //             onClick={handleRefresh}
// //           >
// //             Refresh
// //           </Button>
// //         </DialogActions>
// //       </Dialog>

// //       <Routes>
// //         {/* Public */}
// //         <Route path="/ChangeDefaultPassword" element={<ChangePassword />} />
// //         <Route path="/" element={<SSOPlant />} />

// //         {/* Main Layout */}
// //         <Route element={<MainLayout mode={mode} toggleTheme={toggleTheme} />}>
// //           <Route element={<DashboardLayout />}>
// //             <Route path="/admin/:category" element={<AdminCategoryConfig />} />

// //             {/* Dashboards */}
// //             <Route path="/managers" element={<LandingPage />} />
// //             <Route path="/managers/dashboard" element={<Dashboard />} />
// //             <Route path="/hr/dashboard" element={<Dashboard />} />

// //             {/* Tabs */}
// //             <Route path="/managers/dashboard/upcomingexams" element={<OverviewTab mode="upcoming" />} />
// //             <Route path="/managers/dashboard/completedexams" element={<OverviewTab mode="completed" />} />
// //             <Route path="/managers/dashboard/leaderboards" element={<LeaderboardTab />} />

// //             {/* HR */}
// //             <Route path="/hr/assign-course" element={<AssignCourse />} />
// //             <Route path="/hr/assignment-exams" element={<ListofAssignmentExams />} />
// //             <Route path="/hr/employee-slots" element={<EmployeeSlotsTable />} />
// //             <Route path="/hr/slots" element={<SlotBookingPage />} />

// //             <Route path="/hr/dashboard/upcomingexams" element={<OverviewTab mode="upcoming" />} />
// //             <Route path="/hr/dashboard/completedexams" element={<OverviewTab mode="completed" />} />
// //             <Route path="/hr/dashboard/leaderboards" element={<LeaderboardTab />} />

// //             {/* Manager */}
// //             <Route path="/managers/exams-list" element={<ListofExams />} />
// //             <Route path="/managers/create-course/:type/:examid" element={<CreateCourse />} />

// //             {/* Reports */}
// //             <Route path="/report" element={<ReportsTable />} />
// //             <Route path="/report/users" element={<ReportsUser />} />
// //             <Route path="/user/reports" element={<ReportsUserWise />} />

// //             {/* User */}
// //             <Route path="/users/dashboard" element={<NewEmpDashboard />} />

// //             {/* Navigation */}
// //             <Route path="/AdminHome" element={<AdminHome />} />
// //             <Route path="/SuperAdminHome" element={<SuperAdminHome />} />
// //             <Route path="/ServiceProviderHome" element={<ServiceProviderHome />} />
// //             <Route path="/ChangePlant" element={<ChangePlant />} />

// //             <Route path="/review" element={<ReviewPage />} />
// //             <Route path="/error" element={<ErrorPage />} />
// //           </Route>
// //         </Route>

// //         {/* Standalone */}
// //         <Route path="/instructions" element={<Instructions />} />
// //         <Route path="/instructions/:ee_id" element={<VivaInstructions />} />
// //         <Route path="/vivaexam/:ee_id" element={<VivaCompetitiveExam />} />
// //         <Route path="/assignment" element={<ExamPortal />} />

// //         <Route path="/pdfreport" element={<Pdfviewer />} />

// //         {/* Dummy */}
// //         <Route path="/dummy-instructions" element={<DummyExamInstructions />} />
// //         <Route path="/confirm-startdialogdemo" element={<ConfirmStartDialogDemo />} />
// //         <Route path="/examportal-mock" element={<ExamPortalMock />} />
// //         <Route path="/submitexamdialog-demo" element={<SubmitExamDialogDemo />} />
// //         <Route path="/dummy-viva-instructions" element={<DummyVivaInstructions />} />
// //         <Route path="/dummy-viva-exam" element={<DummyVivaCompetitiveExam />} />
// //       </Routes>
// //     </MuiThemeProvider>
// //   );
// // }

// // // ---------------- Root ----------------
// // export default function App() {
// //   return (
// //     <BrowserRouter>
// //       <ThemeProvider>
// //         <TourProvider>
// //           <AppWrapper />
// //         </TourProvider>
// //       </ThemeProvider>
// //     </BrowserRouter>
// //   );
// // }


// import React, { useState, useEffect, useMemo } from "react";
// import {
//   BrowserRouter,
//   Routes,
//   Route,
//   Navigate,
//   useNavigate,
//   useLocation,
// } from "react-router-dom";

// import {
//   ThemeProvider as MuiThemeProvider,
//   createTheme,
//   CssBaseline,
//   useMediaQuery,
// } from "@mui/material";

// // Theme
// import { ThemeProvider } from "./css/ThemeContext";
// import ThemeSelector from "./css/ThemeSelector";

// // Layout
// import MainLayout from "./MainLayout";
// import DashboardLayout from "./Temp/Dashboard/DashboardLayout";

// // Auth
// import { AuthInterceptor } from "./UserManagement/Logout";

// // Pages
// import ChangePassword from "./UserManagement/ChangeDefaultPassword";
// import ErrorPage from "./UserManagement/ErrorPage";
// import AdminHome from "./UserManagement/AdminHome";
// import SuperAdminHome from "./UserManagement/SuperAdmin";
// import ServiceProviderHome from "./UserManagement/ServiceProvider";
// import ChangePlant from "./UserManagement/ChangePlant";

// import AssignCourse from "./HR/Assign_Course/AssignCourse";
// import ListofAssignmentExams from "./HR/Assign_Course/list_of_assignments/ListofAssignmentExams";
// import EmployeeSlotsTable from "./HR/EmployeeSlots/EmployeeSlotsTable";
// import SlotBookingPage from "./HR/EmployeeSlots/SlotBooking";

// import { ReportsTable } from "./Reports/ReportsTable";
// import { ReportsUser } from "./Reports/ReportsUser";
// import { ReportsUserWise } from "./Reports/UserWiseReports";

// import LandingPage from "./Temp/Dashboard/LandingPage";
// import { Dashboard } from "./Dashboard/Dashboard";
// import OverviewTab from "./Manager/NewDashboard/components/OverviewTab";
// import LeaderboardTab from "./Manager/NewDashboard/components/LeaderboardTab";

// import ListofExams from "./Manager/list-of-exams/ListofExams";
// import { CreateCourse } from "./Manager/create-course/CreateCourse";

// import ReviewPage from "./Review/Reviewpage";
// import NewEmpDashboard from "./TempUser/NewEmpDashboard";

// import Instructions from "./ExamPage/Instructions";
// import VivaInstructions from "./VivaExam/VivaInstructions";
// import { VivaCompetitiveExam } from "./VivaExam/VivaCompetitiveExam";
// import ExamPortal from "./ExamPage/Exam";

// import Pdfviewer from "./pdf/Pdfviewer";

// import DummyExamInstructions from "./TempUser/UserWelcomeGuide/dummyExamInstructions";
// import ConfirmStartDialogDemo from "./TempUser/UserWelcomeGuide/ConfirmStartDialogDemo";
// import ExamPortalMock from "./TempUser/UserWelcomeGuide/ExamPortalMock";
// import SubmitExamDialogDemo from "./TempUser/UserWelcomeGuide/SubmitExamDialogDemo";

// import DummyVivaInstructions from "./DummyViva/DummyVivaInstructions";
// import DummyVivaCompetitiveExam from "./DummyViva/DummyVivaCompetitiveExam";

// import { TourProvider } from "./User/TourContext";

// // SSO
// import SSOPlant from "./Sso_ums/SsoPlant";

// import AdminCategoryConfig from "./AdminConfig/AdminCategoryConfig";

// // ---------------- ProtectedRoute ----------------
// const ProtectedRoute = ({ element }) => {
//   const location = useLocation();
//   const [allowedUrls, setAllowedUrls] = useState([]);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const path = location.pathname.toLowerCase();

//   if (loading) return <div>Loading...</div>;
//   if (error) return <Navigate to="/error" />;

//   const isAllowed = allowedUrls.some((url) =>
//     path.endsWith(url.toLowerCase())
//   );

//   return isAllowed ? element : <Navigate to="/error" />;
// };

// // ---------------- AppWrapper ----------------
// function AppWrapper() {
//   const preferDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
//   const [mode, setMode] = useState("light");
//   const navigate = useNavigate();
//   const location = useLocation();

//   // ============================
//   // Browser BACK button with browser alert
//   // ============================
//   useEffect(() => {
//     const handleBack = (event) => {
//       event.preventDefault();

//       // Show browser's default alert
//       const confirmLeave = window.confirm(
//         "Are you sure you want to go back? Any unsaved changes may be lost."
//       );

//       if (confirmLeave) {
//         // User clicked OK - navigate back
//         navigate(-1);
//       } else {
//         // User clicked Cancel - stay on page
//         window.history.pushState(null, "", window.location.href);
//       }
//     };

//     // Push initial state
//     window.history.pushState(null, "", window.location.href);
//     window.addEventListener("popstate", handleBack);

//     return () => {
//       window.removeEventListener("popstate", handleBack);
//     };
//   }, [navigate]);

//   // ============================
//   // Refresh / F5 / Close tab with browser alert
//   // ============================
//   useEffect(() => {
//     const handleBeforeUnload = (event) => {
//       // Show browser's default alert
//       event.preventDefault();
//       event.returnValue = "Are you sure you want to leave? Any unsaved changes may be lost.";
//       return event.returnValue;
//     };

//     // Detect F5 / Ctrl+R / Cmd+R
//     const handleKeyDown = (event) => {
//       // F5 key
//       if (event.key === 'F5') {
//         event.preventDefault();
//         // Show browser's default alert
//         const confirmRefresh = window.confirm(
//           "Are you sure you want to refresh? Any unsaved changes may be lost."
//         );
//         if (confirmRefresh) {
//           window.location.reload();
//         }
//         return;
//       }

//       // Ctrl+R or Cmd+R
//       if ((event.ctrlKey || event.metaKey) && event.key === 'r') {
//         event.preventDefault();
//         // Show browser's default alert
//         const confirmRefresh = window.confirm(
//           "Are you sure you want to refresh? Any unsaved changes may be lost."
//         );
//         if (confirmRefresh) {
//           window.location.reload();
//         }
//         return;
//       }
//     };

//     window.addEventListener("beforeunload", handleBeforeUnload);
//     window.addEventListener("keydown", handleKeyDown);

//     return () => {
//       window.removeEventListener("beforeunload", handleBeforeUnload);
//       window.removeEventListener("keydown", handleKeyDown);
//     };
//   }, []);

//   // ============================
//   // SSO-safe interceptor
//   // ============================
//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const code = params.get("code");
//     console.log(code, "codeeeeeeeeeee");
//   }, [navigate, location]);

//   // ============================
//   // Theme setup
//   // ============================
//   useEffect(() => {
//     const savedMode = localStorage.getItem("themeMode");
//     setMode(savedMode || (preferDarkMode ? "dark" : "light"));
//   }, [preferDarkMode]);

//   const toggleTheme = () => {
//     setMode((prev) => {
//       const next = prev === "light" ? "dark" : "light";
//       localStorage.setItem("themeMode", next);
//       return next;
//     });
//   };

//   const theme = useMemo(
//     () =>
//       createTheme({
//         palette: { mode },
//       }),
//     [mode]
//   );

//   return (
//     <MuiThemeProvider theme={theme}>
//       <CssBaseline />
//       <ThemeSelector />

//       <Routes>
//         {/* Public */}
//         <Route path="/ChangeDefaultPassword" element={<ChangePassword />} />
//         <Route path="/" element={<SSOPlant />} />

//         {/* Main Layout */}
//         <Route element={<MainLayout mode={mode} toggleTheme={toggleTheme} />}>
//           <Route element={<DashboardLayout />}>
//             <Route path="/admin/:category" element={<AdminCategoryConfig />} />

//             {/* Dashboards */}
//             <Route path="/managers" element={<LandingPage />} />
//             <Route path="/managers/dashboard" element={<Dashboard />} />
//             <Route path="/hr/dashboard" element={<Dashboard />} />

//             {/* Tabs */}
//             <Route path="/managers/dashboard/upcomingexams" element={<OverviewTab mode="upcoming" />} />
//             <Route path="/managers/dashboard/completedexams" element={<OverviewTab mode="completed" />} />
//             <Route path="/managers/dashboard/leaderboards" element={<LeaderboardTab />} />

//             {/* HR */}
//             <Route path="/hr/assign-course" element={<AssignCourse />} />
//             <Route path="/hr/assignment-exams" element={<ListofAssignmentExams />} />
//             <Route path="/hr/employee-slots" element={<EmployeeSlotsTable />} />
//             <Route path="/hr/slots" element={<SlotBookingPage />} />

//             <Route path="/hr/dashboard/upcomingexams" element={<OverviewTab mode="upcoming" />} />
//             <Route path="/hr/dashboard/completedexams" element={<OverviewTab mode="completed" />} />
//             <Route path="/hr/dashboard/leaderboards" element={<LeaderboardTab />} />

//             {/* Manager */}
//             <Route path="/managers/exams-list" element={<ListofExams />} />
//             <Route path="/managers/create-course/:type/:examid" element={<CreateCourse />} />

//             {/* Reports */}
//             <Route path="/report" element={<ReportsTable />} />
//             <Route path="/report/users" element={<ReportsUser />} />
//             <Route path="/user/reports" element={<ReportsUserWise />} />

//             {/* User */}
//             <Route path="/users/dashboard" element={<NewEmpDashboard />} />

//             {/* Navigation */}
//             <Route path="/AdminHome" element={<AdminHome />} />
//             <Route path="/SuperAdminHome" element={<SuperAdminHome />} />
//             <Route path="/ServiceProviderHome" element={<ServiceProviderHome />} />
//             <Route path="/ChangePlant" element={<ChangePlant />} />

//             <Route path="/review" element={<ReviewPage />} />
//             <Route path="/error" element={<ErrorPage />} />
//           </Route>
//         </Route>

//         {/* Standalone */}
//         <Route path="/instructions" element={<Instructions />} />
//         <Route path="/instructions/:ee_id" element={<VivaInstructions />} />
//         <Route path="/vivaexam/:ee_id" element={<VivaCompetitiveExam />} />
//         <Route path="/assignment" element={<ExamPortal />} />

//         <Route path="/pdfreport" element={<Pdfviewer />} />

//         {/* Dummy */}
//         <Route path="/dummy-instructions" element={<DummyExamInstructions />} />
//         <Route path="/confirm-startdialogdemo" element={<ConfirmStartDialogDemo />} />
//         <Route path="/examportal-mock" element={<ExamPortalMock />} />
//         <Route path="/submitexamdialog-demo" element={<SubmitExamDialogDemo />} />
//         <Route path="/dummy-viva-instructions" element={<DummyVivaInstructions />} />
//         <Route path="/dummy-viva-exam" element={<DummyVivaCompetitiveExam />} />
//       </Routes>
//     </MuiThemeProvider>
//   );
// }

// // ---------------- Root ----------------
// export default function App() {
//   return (
//     <BrowserRouter>
//       <ThemeProvider>
//         <TourProvider>
//           <AppWrapper />
//         </TourProvider>
//       </ThemeProvider>
//     </BrowserRouter>
//   );
// }



import React, { useState, useEffect, useMemo } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";

import {
  ThemeProvider as MuiThemeProvider,
  createTheme,
  CssBaseline,
  useMediaQuery,
} from "@mui/material";

// Theme
import { ThemeProvider } from "./css/ThemeContext";
import ThemeSelector from "./css/ThemeSelector";

// Layout
import MainLayout from "./MainLayout";
import DashboardLayout from "./Temp/Dashboard/DashboardLayout";

// Auth
import { AuthInterceptor } from "./UserManagement/Logout";

// Pages
// import ChangePassword from "./UserManagement/ChangeDefaultPassword";
import ErrorPage from "./UserManagement/ErrorPage";
// import AdminHome from "./UserManagement/AdminHome";
// import SuperAdminHome from "./UserManagement/SuperAdmin";
// import ServiceProviderHome from "./UserManagement/ServiceProvider";
import ChangePlant from "./UserManagement/ChangePlant";

import AssignCourse from "./HR/Assign_Course/AssignCourse";
import ListofAssignmentExams from "./HR/Assign_Course/list_of_assignments/ListofAssignmentExams";
import EmployeeSlotsTable from "./HR/EmployeeSlots/EmployeeSlotsTable";
import SlotBookingPage from "./HR/EmployeeSlots/SlotBooking";

import { ReportsTable } from "./Reports/ReportsTable";
import { ReportsUser } from "./Reports/ReportsUser";
import { ReportsUserWise } from "./Reports/UserWiseReports";
import EmployeeCoursesReport from "./Reports/EmployeeCoursesReport";

import LandingPage from "./Temp/Dashboard/LandingPage";
import { Dashboard } from "./Dashboard/Dashboard";
import OverviewTab from "./Manager/NewDashboard/components/OverviewTab";
import LeaderboardTab from "./Manager/NewDashboard/components/LeaderboardTab";

import ListofExams from "./Manager/list-of-exams/ListofExams";
import { CreateCourse } from "./Manager/create-course/CreateCourse";

import ReviewPage from "./Review/Reviewpage";
import NewEmpDashboard from "./TempUser/NewEmpDashboard";

import Instructions from "./ExamPage/Instructions";
import VivaInstructions from "./VivaExam/VivaInstructions";
import { VivaCompetitiveExam } from "./VivaExam/VivaCompetitiveExam";
import ExamPortal from "./ExamPage/Exam";

import Pdfviewer from "./pdf/Pdfviewer";

import DummyExamInstructions from "./TempUser/UserWelcomeGuide/dummyExamInstructions";
import ConfirmStartDialogDemo from "./TempUser/UserWelcomeGuide/ConfirmStartDialogDemo";
import ExamPortalMock from "./TempUser/UserWelcomeGuide/ExamPortalMock";
import SubmitExamDialogDemo from "./TempUser/UserWelcomeGuide/SubmitExamDialogDemo";

import DummyVivaInstructions from "./DummyViva/DummyVivaInstructions";
import DummyVivaCompetitiveExam from "./DummyViva/DummyVivaCompetitiveExam";

import { TourProvider } from "./User/TourContext";

// SSO
import SSOPlant from "./Sso_ums/SsoPlant";

import AdminCategoryConfig from "./AdminConfig/AdminCategoryConfig";
import { LLM_Configuration } from "./AdminConfig/LLM_Configuration";





// ---------------- ProtectedRoute ----------------
const ProtectedRoute = ({ element }) => {
  const location = useLocation();
  const [allowedUrls, setAllowedUrls] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const path = location.pathname.toLowerCase();

  if (loading) return <div>Loading...</div>;
  if (error) return <Navigate to="/error" />;

  const isAllowed = allowedUrls.some((url) =>
    path.endsWith(url.toLowerCase())
  );

  return isAllowed ? element : <Navigate to="/error" />;
};

// ---------------- Custom Hook for Protected Routes ----------------
const useProtectedRoutes = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Define the routes that should have alerts
  const protectedPaths = [
    '/admin/:category',
    '/hr/assign-course',
    '/managers/create-course/:type/:examid',
    // '/instructions',
    // '/assignment',
    // '/instructions/:ee_id',
    // '/vivaexam/:ee_id'
  ];

  // Check if current path matches any protected route pattern
  const isProtectedRoute = useMemo(() => {
    const currentPath = location.pathname;

    return protectedPaths.some(pattern => {
      // Convert route pattern to regex
      const regexPattern = pattern
        .replace(/:[^\s/]+/g, '([^/]+)') // Replace :param with regex group
        .replace(/\//g, '\\/'); // Escape forward slashes

      const regex = new RegExp(`^${regexPattern}$`);
      return regex.test(currentPath);
    });
  }, [location.pathname, protectedPaths]);

  return { isProtectedRoute, currentPath: location.pathname };
};

// ---------------- AppWrapper ----------------
function AppWrapper() {
  const preferDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const [mode, setMode] = useState("light");
  const navigate = useNavigate();
  const location = useLocation();

  // Get protected route status
  const { isProtectedRoute } = useProtectedRoutes();

  // ============================
  // Browser BACK button with browser alert (only for protected routes)
  // ============================
  useEffect(() => {
    // Only apply if current route is protected
    if (!isProtectedRoute) return;

    const handleBack = (event) => {
      event.preventDefault();

      const hasUnsavedChanges =
        sessionStorage.getItem("hasUnsavedChanges") === "true";

      if (!hasUnsavedChanges) {
        navigate(-1);
        return;
      }

      // Show browser's default alert
      const confirmLeave = window.confirm(
        "Are you sure you want to go back? Any unsaved changes may be lost."
      );

      if (confirmLeave) {
        // User clicked OK - navigate back
        navigate(-1);
      } else {
        // User clicked Cancel - stay on page
        window.history.pushState(null, "", window.location.href);
      }
    };

    // Push initial state
    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handleBack);

    return () => {
      window.removeEventListener("popstate", handleBack);
    };
  }, [navigate, isProtectedRoute]);

  // ============================
  // Refresh / F5 / Close tab with browser alert (only for protected routes)
  // ============================
  useEffect(() => {
    // Only apply if current route is protected
    if (!isProtectedRoute) return;

    const handleBeforeUnload = (event) => {
      // Show browser's default alert
      event.preventDefault();
      event.returnValue = "Are you sure you want to leave? Any unsaved changes may be lost.";
      return event.returnValue;
    };

    // Detect F5 / Ctrl+R / Cmd+R
    const handleKeyDown = (event) => {
      // F5 key
      if (event.key === 'F5') {
        event.preventDefault();
        // Show browser's default alert
        const confirmRefresh = window.confirm(
          "Are you sure you want to refresh? Any unsaved changes may be lost."
        );
        if (confirmRefresh) {
          window.location.reload();
        }
        return;
      }

      // Ctrl+R or Cmd+R
      if ((event.ctrlKey || event.metaKey) && event.key === 'r') {
        event.preventDefault();
        // Show browser's default alert
        const confirmRefresh = window.confirm(
          "Are you sure you want to refresh? Any unsaved changes may be lost."
        );
        if (confirmRefresh) {
          window.location.reload();
        }
        return;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isProtectedRoute]);

  // ============================
  // SSO-safe interceptor
  // ============================
  useEffect(() => {
    AuthInterceptor(navigate);
  }, [navigate]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    console.log(code, "codeeeeeeeeeee");
  }, [navigate, location]);

  // ============================
  // Theme setup
  // ============================
  useEffect(() => {
    const savedMode = localStorage.getItem("themeMode");
    setMode(savedMode || (preferDarkMode ? "dark" : "light"));
  }, [preferDarkMode]);

  const toggleTheme = () => {
    setMode((prev) => {
      const next = prev === "light" ? "dark" : "light";
      localStorage.setItem("themeMode", next);
      return next;
    });
  };

  const theme = useMemo(
    () =>
      createTheme({
        palette: { mode },
      }),
    [mode]
  );

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <ThemeSelector />

      <Routes>
        {/* Public */}
        {/* <Route path="/ChangeDefaultPassword" element={<ChangePassword />} /> */}
        <Route path="/" element={<SSOPlant />} />

        {/* Main Layout */}
        <Route element={<MainLayout mode={mode} toggleTheme={toggleTheme} />}>
          <Route element={<DashboardLayout />}>
            <Route path="/admin/:category" element={<AdminCategoryConfig />} />
            <Route path="/admin/llm_config" element={<LLM_Configuration />} />

            {/* Dashboards */}
            <Route path="/managers" element={<LandingPage />} />
            <Route path="/managers/dashboard" element={<Dashboard />} />
            <Route path="/hr/dashboard" element={<Dashboard />} />

            {/* Tabs */}
            <Route path="/managers/dashboard/upcomingexams" element={<OverviewTab mode="upcoming" />} />
            <Route path="/managers/dashboard/completedexams" element={<OverviewTab mode="completed" />} />
            <Route path="/managers/dashboard/leaderboards" element={<LeaderboardTab />} />

            {/* HR */}
            <Route path="/hr/assign-course" element={<AssignCourse />} />
            <Route path="/hr/assignment-exams" element={<ListofAssignmentExams />} />
            <Route path="/hr/employee-slots" element={<EmployeeSlotsTable />} />
            <Route path="/hr/slots" element={<SlotBookingPage />} />

            <Route path="/hr/dashboard/upcomingexams" element={<OverviewTab mode="upcoming" />} />
            <Route path="/hr/dashboard/completedexams" element={<OverviewTab mode="completed" />} />
            <Route path="/hr/dashboard/leaderboards" element={<LeaderboardTab />} />

            {/* Manager */}
            <Route path="/managers/exams-list" element={<ListofExams />} />
            <Route path="/managers/create-course/:type/:examid" element={<CreateCourse />} />

            {/* Reports */}
            <Route path="/report" element={<ReportsTable />} />
            <Route path="/report/users" element={<ReportsUser />} />
            <Route path="/report/employee-courses" element={<EmployeeCoursesReport />} />
            <Route path="/user/reports" element={<ReportsUserWise />} />

            <Route path="/report/employee-courses" element={<EmployeeCoursesReport />} />
 

            {/* User */}
            <Route path="/users/dashboard" element={<NewEmpDashboard />} />

            {/* Navigation */}
            {/* <Route path="/AdminHome" element={<AdminHome />} /> */}
            {/* <Route path="/SuperAdminHome" element={<SuperAdminHome />} /> */}
            {/* <Route path="/ServiceProviderHome" element={<ServiceProviderHome />} /> */}
            <Route path="/ChangePlant" element={<ChangePlant />} />

            <Route path="/review" element={<ReviewPage />} />
            <Route path="/error" element={<ErrorPage />} />

            
          </Route>
        </Route>

        {/* Standalone */}
        <Route path="/instructions" element={<Instructions />} />
        <Route path="/instructions/:ee_id" element={<VivaInstructions />} />
        <Route path="/vivaexam/:ee_id" element={<VivaCompetitiveExam />} />
        <Route path="/assignment" element={<ExamPortal />} />

        <Route path="/pdfreport" element={<Pdfviewer />} />

        {/* Dummy */}
        <Route path="/dummy-instructions" element={<DummyExamInstructions />} />
        <Route path="/confirm-startdialogdemo" element={<ConfirmStartDialogDemo />} />
        <Route path="/examportal-mock" element={<ExamPortalMock />} />
        <Route path="/submitexamdialog-demo" element={<SubmitExamDialogDemo />} />
        <Route path="/dummy-viva-instructions" element={<DummyVivaInstructions />} />
        <Route path="/dummy-viva-exam" element={<DummyVivaCompetitiveExam />} />
      </Routes>
    </MuiThemeProvider>
  );
}

// ---------------- Root ----------------
export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <TourProvider>
          <AppWrapper />
        </TourProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
